import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import AppConstants, {
  api_error,
  BusinessType as BT,
  CarrierApprovalInfo as CAT,
  SRO,
  stateCodes,
  stateCountry,
  TransportationType as TT,
  TransportType as TST,
  VehicleType as VT,
  CarrierApprovalInfo as CAI
} from '../../shared/common-components/AppConstants';
import {HhgCarrierRateFilingService} from './hhg-carrier-rate-filing.service';
import { RateTypes, SROMaster} from './hhgrates';
import {StateCountry, RatesSroMaster, RateTypesSro} from '../../shared/common-components/common-structure';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {BehaviorSubject, of, takeWhile, timer} from 'rxjs';
import moment from 'moment';
import {Router} from '@angular/router';

@Component({
    selector: 'app-hhg-carrier-rate-filing',
    templateUrl: './hhg-carrier-rate-filing.component.html',
    styleUrls: ['./hhg-carrier-rate-filing.component.css'],
    standalone: false
})
export class HhgCarrierRateFilingComponent implements OnInit, OnDestroy {
  showCode: boolean;
  isSitMandatory: Boolean = false;
  isAccUabMandatory: Boolean = false;
  isUabMandatory: Boolean = false;
  isVehicleMandatory: Boolean = true;

  /**
   * @description injects all the required services; initializes the form; retrieves carries approval info based on the carrier ID.
   */
  constructor(private fb: UntypedFormBuilder, private hhgService: HhgCarrierRateFilingService, private carrierService: CarrierService,
              private alertService: AlertService, private loader: LoadingService, private userService: UserService, private router: Router) {
    this.tmssloader = this.loader;

    /**
     * @description getting current user from the behavioural subject
     */
    this.tmssloader.show();
    this.hhgService.getCarrierIdByUser().subscribe(carrierId => {
      this.carrierId = carrierId;
      if (this.carrierId !== undefined && this.carrierId !== null) {
        this.getCarrierApprovalInfo();
      }
      this.tmssloader.hide();
    }, (error) => {
      this.tmssloader.hide();
      this.alertService.error('Unable to load carrier info values. Please try again later or contact system administrator');
    });
    this.createForm();

    /*    this.hhgService.getControlTypesRateFiling().subscribe(res => {
          this.controlTypeVal = res;
        }, error => {
          this.alertService.error('Control Type values are unable to load. Please contact administrator or try again after sometime.');
        });*/
    this.getRatesBidcyclesId();

  }

  currentUser: User | any;
  carrierId: any;
  private tmssloader;
  // controlTypeVal: any;
  ratesBidcycle: any;
  bidcycleName: any;
  hhgCarrierRates: UntypedFormGroup;
  transportTypes = [TST.INTERSTATE, TST.INTRASTATE, TST.INTERNATIONAL];
  rateTypes: RateTypes[];
  rateTypesByTransport: RateTypes[];
  observer$ = new BehaviorSubject(true);
  isRateFilingClosed$ =  new BehaviorSubject(false);
  carrierApprovalInfo: any[];
  agencies: RatesSroMaster[];
  agenciesInterstate: RatesSroMaster[];
  agenciesInternational: RatesSroMaster[];
  agenciesIntrastate: RatesSroMaster[];
  agenciesByRateType: RatesSroMaster[];
  rateTypesSroList: RateTypesSro[];
  stateCountries: StateCountry[];
  destinationByType: StateCountry[];
  originByType: StateCountry[];
  rateTypeError: boolean;
  rateTypeErrorMessage = [];
  agencyError: boolean;
  agencyErrorMessage: string;
  originError: boolean;
  originErrorMessage: string;
  destinationError: boolean;
  destinationProcureError: boolean;
  destinationErrorMessage: string;
  destinationProcureErrorMessage: string;
  showDiscountFieldsByTransport: boolean;
  showDiscountFieldsText: boolean;
  showDiscountFieldsAlaskaText: boolean;
  showXtosTransportTypeText: boolean;
  showDiscountFieldsByRate: boolean;
  packagingDiscountError: boolean;
  packagingDiscountErrorMessage: string;
  packagingDiscountWarning: boolean;
  packagingDiscountWarningMessage: string;
  wareHouseError: boolean;
  wareHouseErrorMessage: string;
  wareHouseWarning: boolean;
  wareHouseWarningMessage: string;
  monthlyStorageError: boolean;
  monthlyStorageErrorMessage: string;
  monthlyStorageWarning: boolean;
  monthlyStorageWarningMessage: string;
  transportationError: boolean;
  transportationErrorMessage: string;
  transportationWarning: boolean;
  transportationWarningMessage: string;
  sitError: boolean;
  sitErrorMessage: string;
  sitWarning: boolean;
  sitWarningMessage: string;
  accSvcsError: boolean;
  accSvcsErrorMessage: string;
  uabError: boolean;
  uabOriginError: boolean;
  discountFieldSitError: boolean;
  discountFieldSitErrorMessage: string;
  discountFieldMonthlyStorageError: boolean;
  discountFieldMonthlyStorageErrorMessage: string;
  uabErrorMessage: string;
  categoryVehicle1Error: boolean;
  categoryVehicle1ErrorMessage: string;
  categoryVehicle1Warning: boolean;
  categoryVehicle1WarningMessage: string;
  categoryVehicle2Error: boolean;
  categoryVehicle2ErrorMessage: string;
  categoryVehicle2Warning: boolean;
  categoryVehicle2WarningMessage: string;
  categoryVehicle3Error: boolean;
  categoryVehicle3ErrorMessage: string;
  categoryVehicle3Warning: boolean;
  categoryVehicle3WarningMessage: string;
  errorMessages: any;
  isErrorMessages = false;
  showDestination: Boolean = true;
  showIntrastateMessage: Boolean = false;
  packagingMaxLength;
  deliveryMaxLength;
  isExtendedStorage;
  isMCFFAvailable: number=0; //0- no MC or FF; 1 has only MC; 2 has only FF; 3 has both MC and FF
  messageForMCAndFF: string = "";

  static agencyTypeCondition(agencyType) {
    return agencyType.sroId === SRO.CCNTL || agencyType.sroId === SRO.EXSTG || agencyType.sroId === SRO.XSARC;

  }

  static alaskaOriginDestinationCondition(origin, destination) {
    return (origin.stateCountryCode === stateCodes.KN &&  destination.stateCountryCode === '2204') ||
      (origin.stateCountryCode === stateCodes.KD &&  destination.stateCountryCode === '2205') ||
      (origin.stateCountryCode === stateCodes.AN &&  destination.stateCountryCode === '2200') ||
      (origin.stateCountryCode === stateCodes.CV &&  destination.stateCountryCode === '2201') ||
      (origin.stateCountryCode === stateCodes.FB &&  destination.stateCountryCode === '2202') ||
      (origin.stateCountryCode === stateCodes.JN &&  destination.stateCountryCode === '2203') ||
      (origin.stateCountryCode === stateCodes.PB &&  destination.stateCountryCode === '2206') ||
      (origin.stateCountryCode === stateCodes.SA &&  destination.stateCountryCode === '2207') ||
      (origin.stateCountryCode === stateCodes.WG &&  destination.stateCountryCode === '2208');
  }

  static canadaOriginDestinationCondition(origin, destination) {
    return (origin.stateCountryCode === stateCodes.AB &&  destination.stateCountryCode === '2300') ||
      (origin.stateCountryCode === stateCodes.BC &&  destination.stateCountryCode === '2301') ||
      (origin.stateCountryCode === stateCodes.LB &&  destination.stateCountryCode === '2302') ||
      (origin.stateCountryCode === stateCodes.MB &&  destination.stateCountryCode === '2203') ||
      (origin.stateCountryCode === stateCodes.NB &&  destination.stateCountryCode === '2304') ||
      (origin.stateCountryCode === stateCodes.NF &&  destination.stateCountryCode === '2305') ||
      (origin.stateCountryCode === stateCodes.NL &&  destination.stateCountryCode === '2313') ||
      (origin.stateCountryCode === stateCodes.NS &&  destination.stateCountryCode === '2306') ||
      (origin.stateCountryCode === stateCodes.NT &&  destination.stateCountryCode === '2311') ||
      (origin.stateCountryCode === stateCodes.ON &&  destination.stateCountryCode === '2307') ||
      (origin.stateCountryCode === stateCodes.PE &&  destination.stateCountryCode === '2308') ||
      (origin.stateCountryCode === stateCodes.PQ &&  destination.stateCountryCode === '2309') ||
      (origin.stateCountryCode === stateCodes.SK &&  destination.stateCountryCode === '2310') ||
      (origin.stateCountryCode === stateCodes.YT &&  destination.stateCountryCode === '2312');
  }

  static canadaStatesCodeCondition(val) {
    return val.stateCountryCode === stateCodes.AB || val.stateCountryCode === stateCodes.BC ||
      val.stateCountryCode === stateCodes.LB || val.stateCountryCode === stateCodes.MB || val.stateCountryCode === stateCodes.NB || val.stateCountryCode === stateCodes.NF ||
      val.stateCountryCode === stateCodes.NS || val.stateCountryCode === stateCodes.NT || val.stateCountryCode === stateCodes.ON || val.stateCountryCode === stateCodes.PE ||
      val.stateCountryCode === stateCodes.PQ || val.stateCountryCode === stateCodes.SK || val.stateCountryCode === stateCodes.YT ||
      val.stateCountryCode === '2300' || val.stateCountryCode === '2301' || val.stateCountryCode === '2302' || val.stateCountryCode === '2303' || val.stateCountryCode === '2304' ||
      val.stateCountryCode === '2305' || val.stateCountryCode === '2306' || val.stateCountryCode === '2307' || val.stateCountryCode === '2308' || val.stateCountryCode === '2309' ||
      val.stateCountryCode === '2310' || val.stateCountryCode === '2311' || val.stateCountryCode === '2312' || val.stateCountryCode === '2313';

  }

  static canOrgArrayConditionUab(val) {
    return val.stateCountryCode === stateCodes.AB || val.stateCountryCode === stateCodes.BC || val.stateCountryCode === stateCodes.MB || val.stateCountryCode === stateCodes.NB ||
      val.stateCountryCode === stateCodes.NL || val.stateCountryCode === stateCodes.NS || val.stateCountryCode === stateCodes.NT || val.stateCountryCode === stateCodes.ON ||
      val.stateCountryCode === stateCodes.PE || val.stateCountryCode === stateCodes.PQ || val.stateCountryCode === stateCodes.SK || val.stateCountryCode === stateCodes.YT;

  }

  static dosmmOrgDestSameValCondition(orgVal, destVal) {
    if (orgVal && destVal) {
      return !((orgVal.parentCountryId === 326 && destVal.parentCountryId !==326) ||
        (orgVal.parentCountryId !== 326 && destVal.parentCountryId ===326));
    }
    return false;
  }

  static orgArrayConditionUab(val) {
    return val.stateCountryCode === stateCodes.AN || val.stateCountryCode === stateCodes.CV || val.stateCountryCode === stateCodes.FB || val.stateCountryCode === stateCodes.JN ||
      val.stateCountryCode === stateCodes.KN || val.stateCountryCode === stateCodes.KD || val.stateCountryCode === stateCodes.PB || val.stateCountryCode === stateCodes.SA ||
      val.stateCountryCode === stateCodes.WG;

  }

  static canDesArrayConditionUab(val) {
    return val.stateCountryCode === '2300' || val.stateCountryCode === '2301' || val.stateCountryCode === '2302' || val.stateCountryCode === '2303' || val.stateCountryCode === '2304' ||
      val.stateCountryCode === '2305' || val.stateCountryCode === '2306' || val.stateCountryCode === '2307' || val.stateCountryCode === '2308' || val.stateCountryCode === '2309' ||
      val.stateCountryCode === '2310' || val.stateCountryCode === '2304' || val.stateCountryCode === '2311' || val.stateCountryCode === '2312' || val.stateCountryCode === '2313';

  }

  static desArrayConditionUab(val) {
    return val.stateCountryCode === '2200' || val.stateCountryCode === '2201' || val.stateCountryCode === '2202' || val.stateCountryCode === '2203' || val.stateCountryCode === '2204' ||
      val.stateCountryCode === '2205' || val.stateCountryCode === '2206' || val.stateCountryCode === '2207' || val.stateCountryCode === '2208';

  }

  static continuousStatesCodeCondition(val) {
    return val.stateCountryCode === stateCodes.AZ || val.stateCountryCode === stateCodes.AL || val.stateCountryCode === stateCodes.AR || val.stateCountryCode === stateCodes.CA ||
      val.stateCountryCode === stateCodes.CO || val.stateCountryCode === stateCodes.CT || val.stateCountryCode === stateCodes.DE || val.stateCountryCode === stateCodes.FL ||
      val.stateCountryCode === stateCodes.VA || val.stateCountryCode === stateCodes.MD || val.stateCountryCode === stateCodes.DC || val.stateCountryCode === stateCodes.IL ||
      val.stateCountryCode === stateCodes.IN || val.stateCountryCode === stateCodes.NV || val.stateCountryCode === stateCodes.IA || val.stateCountryCode === stateCodes.NJ ||
      val.stateCountryCode === stateCodes.KS || val.stateCountryCode === stateCodes.NM || val.stateCountryCode === stateCodes.KY || val.stateCountryCode === stateCodes.NY ||
      val.stateCountryCode === stateCodes.MA || val.stateCountryCode === stateCodes.NC || val.stateCountryCode === stateCodes.MI || val.stateCountryCode === stateCodes.ND ||
      val.stateCountryCode === stateCodes.MN || val.stateCountryCode === stateCodes.OH || val.stateCountryCode === stateCodes.MS || val.stateCountryCode === stateCodes.OK ||
      val.stateCountryCode === stateCodes.MO || val.stateCountryCode === stateCodes.OR || val.stateCountryCode === stateCodes.MT || val.stateCountryCode === stateCodes.PA ||
      val.stateCountryCode === stateCodes.RI || val.stateCountryCode === stateCodes.TX || val.stateCountryCode === stateCodes.SC || val.stateCountryCode === stateCodes.UT ||
      val.stateCountryCode === stateCodes.SD || val.stateCountryCode === stateCodes.VT || val.stateCountryCode === stateCodes.TN || val.stateCountryCode === stateCodes.WA ||
      val.stateCountryCode === stateCodes.WV || val.stateCountryCode === stateCodes.WY || val.stateCountryCode === stateCodes.WI || val.stateCountryCode === stateCodes.LA ||
      val.stateCountryCode === stateCodes.NE || val.stateCountryCode === stateCodes.ME || val.stateCountryCode === stateCodes.GA || val.stateCountryCode === stateCodes.ID;

  }

  static alaskaStateExclCodesCondition(val) {
    return val.stateCountryCode === stateCodes.AN || val.stateCountryCode === stateCodes.CV || val.stateCountryCode === stateCodes.FB || val.stateCountryCode === stateCodes.JN ||
      val.stateCountryCode === stateCodes.KN || val.stateCountryCode === stateCodes.KD || val.stateCountryCode === stateCodes.PB || val.stateCountryCode === stateCodes.SA ||
      val.stateCountryCode === stateCodes.WG;
  }

  static alaskaStateCodesCondition(val) {
    return val.stateCountryCode === stateCodes.AN || val.stateCountryCode === stateCodes.CV || val.stateCountryCode === stateCodes.FB || val.stateCountryCode === stateCodes.JN ||
      val.stateCountryCode === stateCodes.KN || val.stateCountryCode === stateCodes.KD || val.stateCountryCode === stateCodes.PB || val.stateCountryCode === stateCodes.SA ||
      val.stateCountryCode === stateCodes.WG || val.stateCountryCode === '2200' || val.stateCountryCode === '2201' || val.stateCountryCode === '2202' || val.stateCountryCode === '2203' ||
      val.stateCountryCode === '2204' || val.stateCountryCode === '2205' || val.stateCountryCode === '2206' || val.stateCountryCode === '2207' || val.stateCountryCode === '2208';

  }

  static internationalOriginAgencyCondition(val) {
    return val.stateCountryCode === stateCodes.AL || val.stateCountryCode === stateCodes.AR || val.stateCountryCode === stateCodes.AZ || val.stateCountryCode === stateCodes.CA ||
      val.stateCountryCode === stateCodes.CO || val.stateCountryCode === stateCodes.CT || val.stateCountryCode === stateCodes.DE || val.stateCountryCode === stateCodes.DC ||
      val.stateCountryCode === stateCodes.FL || val.stateCountryCode === stateCodes.GA || val.stateCountryCode === stateCodes.IA || val.stateCountryCode === stateCodes.ID ||
      val.stateCountryCode === stateCodes.IL || val.stateCountryCode === stateCodes.IN || val.stateCountryCode === stateCodes.KS || val.stateCountryCode === stateCodes.KY ||
      val.stateCountryCode === stateCodes.LA || val.stateCountryCode === stateCodes.MA || val.stateCountryCode === stateCodes.MD || val.stateCountryCode === stateCodes.ME ||
      val.stateCountryCode === stateCodes.MI || val.stateCountryCode === stateCodes.MN || val.stateCountryCode === stateCodes.MO || val.stateCountryCode === stateCodes.MS ||
      val.stateCountryCode === stateCodes.MT || val.stateCountryCode === stateCodes.NC || val.stateCountryCode === stateCodes.NE || val.stateCountryCode === stateCodes.NH ||
      val.stateCountryCode === stateCodes.NJ || val.stateCountryCode === stateCodes.NM || val.stateCountryCode === stateCodes.NV || val.stateCountryCode === stateCodes.NY ||
      val.stateCountryCode === stateCodes.OH || val.stateCountryCode === stateCodes.OK || val.stateCountryCode === stateCodes.PA || val.stateCountryCode === stateCodes.RI ||
      val.stateCountryCode === stateCodes.SC || val.stateCountryCode === stateCodes.SD || val.stateCountryCode === stateCodes.TN || val.stateCountryCode === stateCodes.TX ||
      val.stateCountryCode === stateCodes.UT || val.stateCountryCode === stateCodes.VA || val.stateCountryCode === stateCodes.VT || val.stateCountryCode === stateCodes.WA ||
      val.stateCountryCode === stateCodes.WV || val.stateCountryCode === stateCodes.WI || val.stateCountryCode === stateCodes.WY || val.stateCountryCode === stateCodes.ND;
  }

  /**
   * check in between or not
   * @param n: array
   * @param a: first element
   * @param b: second element
   */
  static between(n, a, b) {
    return (n >= a && n <= b);
  }

  /**
   * getting carrier info
   */
  getCarrierApprovalInfo() {

    this.hhgService.getCarrierApprovalInfo(this.carrierId).subscribe(res => {
      this.carrierApprovalInfo = res;
      this.getMCAndFFIndicatorOnDomesticTSP();
      this.getTransportationType();
    }, error => {
      this.alertService.error('TSP Info values are unable to load. Please contact administrator or try again after sometime.');
    });
  }

  getTransportationType(){
    const carrTypes = this.carrierApprovalInfo.filter(x => (x.approvalType === CAT.DOMESTICHHG || x.approvalType === CAT.INTERNATIONALHHG));
    let domesticTrans = [false, false];
    let internationalTrans = false;
    carrTypes.forEach(x =>{
      if(x.approvalType === CAT.DOMESTICHHG)
        if (AppConstants.isNotNullCondition(x.usDotNumber) && (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber))) domesticTrans = [true, true];

      if (x.approvalType === CAT.INTERNATIONALHHG)
        if (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber) || AppConstants.isNotNullCondition(x.fmcOtiNumber)) internationalTrans = true;
    });
    domesticTrans.push(internationalTrans);
    const removeTrans = [TST.INTERSTATE, TST.INTRASTATE];
    if(!(domesticTrans[0] === domesticTrans[1])) this.transportTypes = this.transportTypes.filter(x => removeTrans.indexOf(x) === -1);
    if(domesticTrans[2] === false) this.transportTypes = this.transportTypes.filter(x => ![TST.INTERNATIONAL].includes(x));
  }

  getMCAndFFIndicatorOnDomesticTSP(){
    const approvalEntity = this.carrierApprovalInfo.find(anApprEntity => anApprEntity.approvalType === CAI.DOMESTICHHG);
    if(AppConstants.isNotNullCondition(approvalEntity)){
      this.isMCFFAvailable = (AppConstants.isNotNullCondition(approvalEntity.ffNumber) && AppConstants.isNotNullCondition(approvalEntity.mcNumber)) ? 3 :
        (AppConstants.isNotNullCondition(approvalEntity.mcNumber)) ? 1 :
          (AppConstants.isNotNullCondition(approvalEntity.ffNumber)) ? 2 : 0;

      /*if(this.isMCFFAvailable === 0){
        this.messageForMCAndFF = "Suspect records - Missing one or more authorities";
      }else{
        this.messageForMCAndFF = "";
      }*/
    }
  }

  /**
   * @description gets the ratesBidCylesid
   */
  getRatesBidcyclesId() {
    this.carrierService.getRateBidCycleId()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(res => {
        this.ratesBidcycle = res.ratesBidcyclesId;
        this.bidcycleName = res.bidcycleName;
      });
  }

  /**
   * @description retrieves all the rateTypes, agency types and state/countries.
   */
  ngOnInit() {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
              this.router.navigate(['/', 'landing']);
            }
          });
      });
    const isExtendedStorage = (element) => element.legacyRateType === 11;
    this.hhgService.getRateTypesByBidCycle(this.ratesBidcycle).subscribe(res => {
      this.rateTypes = res as Array<RateTypes>;
      this.rateTypes.sort(function(a, b) {
        return a.legacyRateType - b.legacyRateType;
      });
      /*      if (this.rateTypes.findIndex(isExtendedStorage) !== -1) {
              this.rateTypes.splice(this.rateTypes.findIndex(isExtendedStorage), 1);
            }*/
    });
    this.hhgService.getSroMasterByBidCycle(this.ratesBidcycle).subscribe(res => {
      if (res !== null && res !== undefined) {
        this.agencies = res;
        this.agencies.sort((a, b) => {
          return (a.sroId < b.sroId) ? -1 : (a.sroId > b.sroId) ? 1 : 0;
        });
        const index = this.agencies.findIndex(agency => agency.sroId == 'GENRL');
        if (index !== -1) {
          const element = this.agencies[index];
          this.agencies.splice(index, 1);
          this.agencies.splice(0, 0, element);
        }
      }
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
    });
    this.hhgService.getAllStateCountries().subscribe(res => {
      this.stateCountries = (res as StateCountry[]);
      this.stateCountries = this.sortingArray(this.stateCountries);
      this.stateCountries.forEach(x => {
        if (HhgCarrierRateFilingComponent.canDesArrayConditionUab(x)) {
          x.stateCountryName = x.stateCountryName + ',CANADA';
        }
      });
    });
    this.hhgCarrierRates.controls['destinationType'].valueChanges.subscribe(value => {
    });
  }

  /**
   * @description initializes the form and its controls.
   */
  createForm() {
    this.hhgCarrierRates = this.fb.group({
      'rateTypeId': new UntypedFormControl('', [Validators.required]),
      'transportType': new UntypedFormControl('', [Validators.required]),
      'carrierId': new UntypedFormControl(''),
      'tenderId': new UntypedFormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
      'sroMasterId': new UntypedFormControl('', [Validators.required]),
      'controlId': this.carrierId,
      'originId': new UntypedFormControl('', [Validators.required]),
      'destinationId': new UntypedFormControl('', [Validators.required]),
      'destinationType': new UntypedFormControl(''),
      // 'transportationPercent' : new FormControl('', [Validators.pattern('^[0-9]+(.[0-9]{0,100})?$')]),
      'linehaul': new UntypedFormControl('', [Validators.required, Validators.pattern('^[\-0-9]+(.[0-9]{0,100})?$')]),
      'classVehicle1': new UntypedFormControl('', [Validators.required]),
      'classVehicle2': new UntypedFormControl('', [Validators.required]),
      'classVehicle3': new UntypedFormControl('', [Validators.required]),
      'storageInTransit': new UntypedFormControl(''),
      'accessorials': new UntypedFormControl(''),
      'unaccompaniedAirBag': new UntypedFormControl(''),
      'bookingEmail': new UntypedFormControl('', [Validators.pattern('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,6})$'), Validators.required]),
      'bookingPhone': new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(15)]),
      'updateFlag': new UntypedFormControl(''),
      'updateProgram': new UntypedFormControl(''),
      'updateId': new UntypedFormControl(''),
      'updateDate': new UntypedFormControl(''),
      // TODO rename this if needed according to the DB
      // 'wareHouseDiscount' : new FormControl(''),
      // 'storageDiscount' : new FormControl(''),
      // 'delivery50mileDiscount' : new FormControl(''),
      // 'deliveryOutDiscount' : new FormControl(''),
    });
  }

  /**
   * @description filters the rate types array based on transport type and reacts to the transport type value change event.
   */
  transportTypeChange() {
    const val = this.getFormField('transportType').value;
    this.isSitMandatory = false;
    this.isAccUabMandatory = false;
    this.isUabMandatory = false;
    this.showIntrastateMessage = false;
    this.getFormField('rateTypeId').setValue('');
    this.getFormField('sroMasterId').setValue('');
    this.getFormField('originId').setValue('');
    this.getFormField('destinationId').setValue('');
    this.hhgCarrierRates.get('destinationId').enable();
    this.getFormField('storageInTransit').clearValidators();
    this.getFormField('accessorials').clearValidators();
    this.getFormField('unaccompaniedAirBag').clearValidators();
    this.resetDiscounts();
    this.rateTypesByTransport = [];
    this.agenciesByRateType = [];
    this.originByType = [];
    this.destinationByType = [];
    this.emptyRateTypeErrors();
    this.emptyAgencyTypeErrors();
    this.emptyDestinationTypeErrors();
    this.emptyOriginTypeErrors();
    this.showDiscountFieldsByType();
    this.clearUabError();
    this.clearUabOriginError();
    switch (val) {
      case TST.INTERSTATE:
        this.rateTypesInterstate();
        this.isSitMandatory = true;
        this.getFormField('storageInTransit').setValidators([Validators.required]);
        break;
      case TST.INTERNATIONAL:
        this.isSitMandatory = true;
        this.rateTypesInternational();
        this.isAccUabMandatory = true;
        this.isUabMandatory = true;
        this.getFormField('accessorials').setValidators([Validators.required]);
        this.getFormField('unaccompaniedAirBag').setValidators([Validators.required]);
        break;
      case TST.INTRASTATE:
        this.isSitMandatory = true;
        this.showIntrastateMessage = true;
        this.rateTypesIntrastate();
        this.getFormField('storageInTransit').setValidators([Validators.required]);
        this.hhgCarrierRates.get('destinationId').disable();
        break;
      default:
        this.emptyRateTypesByTransport();
        break;
    }
  }

  /**
   * @description change event for rate type, handles the validation for combination of rate type and approval carrier info.
   */
  rateTypeChange() {
    const rateType = this.getFormField('rateTypeId').value;
    this.getFormField('sroMasterId').setValue('');
    this.getFormField('originId').setValue('');
    this.getFormField('destinationId').setValue('');
    this.showDestination = true;
    this.getFormField('destinationId').setValidators([Validators.required]);
    this.resetDiscounts();
    this.agenciesByRateType = [];
    this.originByType = [];
    this.destinationByType = [];
    this.emptyRateTypeErrors();
    this.showDiscountFieldsByType();
    this.emptyAgencyTypeErrors();
    this.emptyDestinationTypeErrors();
    this.emptyOriginTypeErrors();
    // this.clearUabError();
    this.clearUabOriginError();
    const transportType = this.getFormField('transportType').value;
    this.filterAgencyByRateType(rateType);
    if (this.carrierApprovalInfo !== null || this.carrierApprovalInfo !== undefined || this.carrierApprovalInfo.length === 0) {
      switch (transportType) {
        case TST.INTERSTATE:
          if (rateType === 11) {
            this.showDestination = false;
            this.getFormField('destinationId').clearValidators();
            this.showXtosTransportTypeText = true;
            this.packagingMaxLength = 6;
            this.deliveryMaxLength = 4;
            this.isExtendedStorage = true;
          } else {
            this.isExtendedStorage = false;
            this.showXtosTransportTypeText = false;
            this.packagingMaxLength = 7;
            this.deliveryMaxLength = 5;
          }
          const carrierInfoExtendedStorage = this.carrierApprovalInfo.filter(x => {
            return x.approvalType === CAT.EXTENDEDSTORAGEHHG;
          });
          const carrierInfoDomestic = this.carrierApprovalInfo.filter(x => {
            return x.approvalType === CAT.DOMESTICHHG;
          });
          if (carrierInfoExtendedStorage === null || carrierInfoExtendedStorage === undefined || carrierInfoExtendedStorage.length === 0) {
            if (rateType === '11' && carrierInfoExtendedStorage.length === 1) {
              // Don't populate anything for type 11. For all other types populate from Service Area.
              // this.destinationByType = [];
              // type=11 and approva_type="extended storage" and approval_new=False
              if (carrierInfoExtendedStorage[0].approvalNew === false) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('TSP Not approved for Extended Storage Operations');
                // type=11 and approva_type="extended storage" and suspended=True
              } else if (carrierInfoExtendedStorage[0].suspended === true) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('TSP has been Suspended for Extended Storage Operations');
                // type=11 and approva_type="extended storage" and tpa=False
              } else if (carrierInfoExtendedStorage[0].tpa === false) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('Extended Storage TPA not on File');
              } else {
                this.emptyRateTypeErrors();
              }
            }
          } else if (carrierInfoDomestic === null || carrierInfoDomestic === undefined || carrierInfoDomestic.length === 0) {
            if (carrierInfoDomestic.length === 1) {
              // Don't populate anything for type 11. For all other types populate from Service Area.
              // this.destinationByServiceArea();
              // approva_type="Domestic HHG" and approval_new=False
              if (carrierInfoDomestic[0].approvalNew === false) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('TSP not approved for Domestic Transportation');
                // approva_type="Domestic HHG" and suspended=True
              } else if (carrierInfoDomestic[0].suspended === true) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('This TSP has been Suspended');
                // approva_type="Domestic HHG" and tpa=False
              } else if (carrierInfoDomestic[0].tpa === false) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('TPA not on file');
              } else {
                this.emptyRateTypeErrors();
              }
            }
          } else {
            this.emptyRateTypeErrors();
          }
          // populating agencies based on rate type.
          if (this.rateTypeError === false && this.rateTypeErrorMessage.length === 0 && this.agencies.length > 0) {
            // skip all these SRO's for all types. FAAIN,DOSDC,FAADC,NOAAA,DOSBG,DOSHW,DOSSA,NBCCO,GEOVA,FSVNM,NPSNE
            this.agenciesInterstate = this.agencies.filter(x => {
              return x.sroId !== SRO.FAAIN && x.sroId !== SRO.DOSDC && x.sroId !== SRO.FAADC && x.sroId !== SRO.NOAAA
                && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSHW && x.sroId !== SRO.DOSSA && x.sroId !== SRO.NBCCO &&
                x.sroId !== SRO.GEOVA && x.sroId !== SRO.FSVNM && x.sroId !== SRO.NPSNE;
            });
            // this.filterAgenciesByRates(rateType, TST.INTERSTATE);
          }
          break;
        case TST.INTERNATIONAL:
          this.isUabMandatory = true;
          const carrierInfoInternational = this.carrierApprovalInfo.filter(x => {
            return x.approvalType === CAT.INTERNATIONALHHG;
          });
          if (carrierInfoInternational === null || carrierInfoInternational === undefined || carrierInfoInternational.length === 0) {
            if (carrierInfoInternational.length === 1) {
              // type=(5 or 6 or 7 or 8)  and bond_identifier = spaces
              if ((rateType === 5 || rateType === 6 || rateType === 7 || rateType === 8) && (carrierInfoInternational[0].bondIdentifier === '' || carrierInfoInternational[0].bondIdentifier === null || carrierInfoInternational[0].bondIdentifier === undefined)) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('International Bond not on File');
                // type=(5 or 6 or 7 or 8)  and (bond_date = spaces)
              } else if ((rateType === 5 || rateType === 6 || rateType === 7 || rateType === 8) &&
                (carrierInfoInternational[0].bondDate === null || carrierInfoInternational[0].bondDate === '' || carrierInfoInternational[0].bondDate === undefined)) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('International Bond Date not on File');
                // type=(9 or 10)  and bond_identifier = spaces
              } else if ((rateType === 9 || rateType === 10) && (carrierInfoInternational[0].bondIdentifier === '' || carrierInfoInternational[0].bondIdentifier === null || carrierInfoInternational[0].bondIdentifier === undefined)) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('DOS Bond not on File');
                // type=(9 or 10)  and (bond_date = spaces)
              } else if ((rateType === 9 || rateType === 10) && (carrierInfoInternational[0].bondDate === null || carrierInfoInternational[0].bondDate === '' || carrierInfoInternational[0].bondDate === undefined)) {
                this.emptyRateTypeErrors();
                this.rateTypeError = true;
                this.rateTypeErrorMessage.push('DOS Bond Date not on File');
                // type=(5 or 6 or 7 or 8)  and  (bond_date < effective_date)
              } else if (this.ratesBidcycle !== null || this.ratesBidcycle !== undefined || this.ratesBidcycle !== '') {
                if ((rateType === 5 || rateType === 6 || rateType === 7 || rateType === 8) && (carrierInfoInternational[0].bondDate < this.ratesBidcycle.rateEffectiveDate)) {
                  this.emptyRateTypeErrors();
                  this.rateTypeError = true;
                  this.rateTypeErrorMessage.push('International Bond has expired');
                  // type=(9 or 10)  and  and  (bond_date < effective_date)
                } else if ((rateType === 9 || rateType === 10) && (carrierInfoInternational[0].bondDate < this.ratesBidcycle.rateEffectiveDate)) {
                  this.emptyRateTypeErrors();
                  this.rateTypeError = true;
                  this.rateTypeErrorMessage.push('DOS Bond has expired');
                } else {
                  this.emptyRateTypeErrors();
                }
              } else {
                this.emptyRateTypeErrors();
              }
            }
          } else {
            this.emptyRateTypeErrors();
          }
          if (this.rateTypeError === false && this.rateTypeErrorMessage.length === 0 && this.agencies.length > 0) {
            this.agenciesInternational = this.agencies.filter(x => {
              return x.sroId !== SRO.DOSDD && x.sroId !== SRO.NOAAA && x.sroId !== SRO.DEADD && x.sroId !== SRO.CCNTL
                && x.sroId !== SRO.EXSTG && x.sroId !== SRO.XSARC && x.sroId !== SRO.FAADC && x.sroId !== SRO.FAAIN &&
                x.sroId !== SRO.NBCCO && x.sroId !== SRO.GEOVA && x.sroId !== SRO.FSVNM && x.sroId !== SRO.NPSNE;
            });
          }
          // this.filterAgenciesByRates(rateType, TST.INTERNATIONAL);
          break;
        case TST.INTRASTATE:
          // Populate all states in Origin dropdown from state_country table with STATE_COUNTRY_TYPE="state"
          // this.destinationByState();
          if (this.agencies.length > 0) {
            this.agenciesIntrastate = this.agencies.filter(x => {
              return x.sroId !== SRO.FAAIN && x.sroId !== SRO.DOSDC && x.sroId !== SRO.FAADC && x.sroId !== SRO.NOAAA
                && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSHW && x.sroId !== SRO.DOSSA && x.sroId !== SRO.NBCCO &&
                x.sroId !== SRO.GEOVA && x.sroId !== SRO.FSVNM && x.sroId !== SRO.NPSNE;
            });
          }
          // this.filterAgenciesByRates(rateType, TST.INTRASTATE);
          this.emptyRateTypeErrors();
          break;
        default:
          this.agenciesByRateType = [];
          this.emptyRateTypeErrors();
          break;
      }
    } else {
      this.alertService.error(`Couldn't able to validate the rate type at this moment. Please try again after sometime or contact your system administrator`);
    }
  }

  /**
   * @description agency selection change event and validates th combination of agency with rate type.
   */
  agencyTypeChange() {
    this.isVehicleMandatory = true;
    this.originByType = [];
    this.destinationByType = [];
    this.resetDiscounts();
    const agencyType = this.getFormField('sroMasterId').value;
    this.emptyAgencyTypeErrors();
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    switch (transportType) {
      case TST.INTERSTATE:
        // type=(1 or 3 or 12 or 14) and SRO != "GENRL"
        if ((rateType === 1 || rateType === 3 || rateType === 12 || rateType === 14) && agencyType.sroId !== SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `The SRO should be GENRL`;
          // type=(1 or 3 or 12 or 14) and SRO != "GENRL"
        } else if ((rateType === 2 || rateType === 4 || rateType === 13 || rateType === 15) && agencyType.sroId === SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `The SRO should not be GENRL`;
          // type=(3 or 4 or 13 or 15) and SRO="NAVDD"
        } else if ((rateType === 3 || rateType === 4 || rateType === 13 || rateType === 15) && agencyType.sroId === SRO.NAVDD) {
          this.agencyError = true;
          this.agencyErrorMessage = `Only General Rates (01,02,12 & 14) are allowed for NAVDD`;
          // type=(3 or 4 or 13 or 15) and SRO="NAVDD"
        } else if (agencyType.sroId === SRO.NBCCO || agencyType.sroId === SRO.GEOVA || agencyType.sroId === SRO.FSVNM || agencyType.sroId === SRO.NPSNE) {
          this.agencyError = true;
          this.agencyErrorMessage = `Agencies consolidated into 'CONDI'`;
          // SRO=FAADC or FAAIN
        } else if (agencyType.sroId === SRO.FAADC || agencyType.sroId === SRO.FAAIN) {
          this.agencyError = true;
          this.agencyErrorMessage = `Invalid Agency`;
          // type = 04 or 15) and SRO=DOSDD or DEADD
        } else if ((rateType === 4 || rateType === 15) && (agencyType.sroId === SRO.DOSDD || agencyType.sroId === SRO.DEADD)) {
          this.agencyError = true;
          this.agencyErrorMessage = `MMS Rates are not permitted for DOSDD and DEADD`;
          // SRO=NAVDD" and rec type != (02 or 01 or 12)
        } else if ((rateType !== 2 || rateType !== 1 || rateType !== 12) && agencyType.sroId === SRO.NAVDD) {
          this.agencyError = true;
          this.agencyErrorMessage = `Types 01,02,12 are only permitted for NAVDD`;
        } else if (rateType !== 9 && agencyType.sroId === SRO.DOSUS) {
          this.agencyError = true;
          this.agencyErrorMessage = `Invalid SRO Id for Rate type 09`;
        } else if (rateType !== 10 && agencyType.sroId === SRO.DOSAS) {
          this.agencyError = true;
          this.agencyErrorMessage = `Invalid SRO Id for Rate type 10`;
        } else {
          this.emptyAgencyTypeErrors();
        }
        if (this.rateTypeError === false && this.agencyError === false && this.rateTypeErrorMessage.length === 0 && this.agencyErrorMessage === '') {
          this.originByTransport();
          this.destinationByTransport();
        }
        break;
      case TST.INTERNATIONAL:
        if ((rateType === 6 || rateType === 8) && agencyType.sroId === SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `SRO ID must be non GENRL`;
        } else if ((rateType === 5 || rateType === 7) && agencyType.sroId !== SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `SRO ID must be GENRL`;
        } else {
          this.emptyAgencyTypeErrors();
          // Error	SRO = "DOSBG" and UAB > Zero	Agency Id DOSBG should not have UAB Weight
          this.agencyUabCondition();
        }
        if (this.rateTypeError === false && this.agencyError === false && this.rateTypeErrorMessage.length === 0 && this.agencyErrorMessage === '') {
          this.originByTransport();
          this.destinationByTransport();
        }
        break;
      case TST.INTRASTATE:
        if ((rateType === 1 || rateType === 3 || rateType === 12 || rateType === 14) && agencyType.sroId !== SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `The SRO should be SRO.GENRL`;
        } else if ((rateType === 2 || rateType === 4 || rateType === 13 || rateType === 15) && agencyType.sroId === SRO.GENRL) {
          this.agencyError = true;
          this.agencyErrorMessage = `The SRO should be SRO.GENRL`;
        } else {
          this.emptyAgencyTypeErrors();
        }
        if (this.rateTypeError === false && this.agencyError === false && this.rateTypeErrorMessage.length === 0 && this.agencyErrorMessage === '') {
          this.originByTransport();
          this.destinationByTransport();
        }
        break;
      default:
        this.originByType = [];
        break;
    }
  }

  /**
   * @description handles the validation of origin value when there is a change
   */
  originTypeChange() {
    const val = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    this.emptyOriginTypeErrors();
    this.emptyAgencyTypeErrors();
    this.emptyDestinationTypeErrors();
    const transportType = this.getFormField('transportType').value;
    const agencyType = this.getFormField('sroMasterId').value;
    const rateType = this.getFormField('rateTypeId').value;
    this.getFormField('destinationId').setValue('');
    this.resetDiscounts();
    switch (transportType) {
      case TST.INTERSTATE:
        // TODO SRO = CCNTL or EXSTG or XSARC ; check the scope of Origin and throw error if not in scope	Origin not in TSP's scope of operation	Scope is stored in rates_tsp_scope table
        // TODO Check the scope of the Origin
        // if Canada is origin for SRO (CCNTL,EXSTG,XSARC), then throw an error.
        if (val.parentCountryId === 365) {
          this.destinationByType = this.destinationByType.filter(x => {
            return x.parentCountryId !== 365;
          });
        }
        if (HhgCarrierRateFilingComponent.canadaStatesCodeCondition(val) && HhgCarrierRateFilingComponent.agencyTypeCondition(agencyType)) {
          this.originError = true;
          this.originErrorMessage = 'Invalid Origin/Destination for the selected Agency';
          // Origin = "9700"
        } else if (val.stateCountryCode === '9700') {
          this.originError = true;
          this.originErrorMessage = `Invalid Int'l (Yugoslavia) Origin`;
          // SRO = DOSHW and Origin != MD00
        } else if (val.stateCountryCode !== stateCodes.MD && agencyType.sroId === SRO.DOSHW) {
          this.originError = true;
          this.originErrorMessage = `DOSHW - Origin Must be MD`;
          // SRO = DOSSA and Origin = MD00 or VA00 or DC00
        } else if ((val.stateCountryCode !== stateCodes.MD && val.stateCountryCode !== stateCodes.VA &&
          val.stateCountryCode !== stateCodes.DC) && agencyType.sroId === SRO.DOSSA) {
          this.originError = true;
          this.originErrorMessage = 'DOSSA- Origin must be VA,MD or DC';
          // SRO = CCNTL or EXSTG or XSARC  and (origin != Alaska-State-Codes-Excl-AK00 and origin != Contiguious State)
        } else {
          this.emptyOriginTypeErrors();
          this.emptyAgencyTypeErrors();
        }
        if (!this.isExtendedStorage) {
          this.checkRateRecordInProcureTable();
        } else {
          this.hhgService.getOriginDestinationProcureValidation(this.carrierId, '374', val.stateCountryId, agencyType.sroMasterId, rateType).subscribe(response => {
            if (response === true) {
              this.originError = true;
              this.originErrorMessage = 'Current record exists, Please update it through edit rates';
            } else {
              this.originError = false;
              this.originErrorMessage = '';
            }
          }, error => {
            this.emptyOriginTypeErrors();
            this.alertService.error(`Couldn't able to get the record from procurement table. Please contact system administrator or try again after sometime.`);
          });
        }
        if ((HhgCarrierRateFilingComponent.alaskaStateCodesCondition(val))  ||
          (HhgCarrierRateFilingComponent.canadaStatesCodeCondition(val))) {
          this.isUabMandatory = true;
          this.getFormField('unaccompaniedAirBag').setValidators([Validators.required]);
          this.uabError = true;
          this.uabOriginError = true;
          this.uabErrorMessage = `UAB Cannot be 0 or blank for Alaskan/Canadian Origin/Destination.`;
        } else {
          this.getFormField('unaccompaniedAirBag').clearValidators();
          this.isUabMandatory = false;
          this.uabError = false;
          this.uabOriginError = false;
          this.uabErrorMessage = ``;
        }

        if (HhgCarrierRateFilingComponent.alaskaStateCodesCondition(val)) {
          this.showDiscountFieldsAlaskaText = true;
          this.showDiscountFieldsText = false;
        } else {
          this.showDiscountFieldsText = rateType === 11 ? false : true;
          this.showDiscountFieldsAlaskaText = false;
        }
        break;
      case TST.INTERNATIONAL:
        // TODO origin not in scope
        // Origin = "9700"
        if (val.stateCountryCode === '9700') {
          this.originError = true;
          this.originErrorMessage = `Invalid Int'l (Yugoslavia) Origin`;
          // (SRO = "DOSHW") and (Origin != "MD00")
        } else if (val.stateCountryCode !== stateCodes.MD && agencyType.sroId === SRO.DOSHW) {
          this.originError = true;
          this.originErrorMessage = `DOSHW - Origin Must be MD`;
          // SRO = "DOSSA" and Origin != ("MD00" or "VA00" or "DC00")
        } else if ((val.stateCountryCode !== stateCodes.MD && val.stateCountryCode !== stateCodes.VA &&
          val.stateCountryCode !== stateCodes.DC) && agencyType.sroId === SRO.DOSSA) {
          this.originError = true;
          this.originErrorMessage = 'DOSSA- Origin must be VA,MD or DC';
          // SRO = "OCCDC"  and Origin !=(ALASKA-CODE or CANADA-CODE or VALID-CONTIGUOUS-ST or 925L)
        } else if ((val.stateCountryCode !== '925L' && !HhgCarrierRateFilingComponent.continuousStatesCodeCondition(val) &&
            !HhgCarrierRateFilingComponent.canadaStatesCodeCondition(val) && !HhgCarrierRateFilingComponent.alaskaStateCodesCondition(val)) &&
          agencyType.sroId === SRO.OCCDC) {
          this.originError = true;
          this.originErrorMessage = 'OCCDC-Origin must be Domestic states or 925L';
          // SRO =  ("CCNTL" or "EXSTG" or "XSARC")  and Origin !=   (ALASKA-ST-CODES-EXCL-AK00 or VALID-CONTIGUOUS-ST)
        } else if (agencyType.sroId === SRO.DOSMM && HhgCarrierRateFilingComponent.dosmmOrgDestSameValCondition(val, destination)) {
          this.destinationError = true;
          this.destinationErrorMessage = 'DOSMM- Country to Country/State to State lanes are not allowed.';
        } else if (HhgCarrierRateFilingComponent.agencyTypeCondition(agencyType) &&
          (!HhgCarrierRateFilingComponent.continuousStatesCodeCondition(val) ||
            !HhgCarrierRateFilingComponent.alaskaStateExclCodesCondition(val))) {
          this.originError = true;
          this.originErrorMessage = 'Origin AK00 or non-CONUS States not allowed';
          // SRO = OCCDC and Origin =(Alaska Code OR Canada Code OR Contiguous State or 925L
        } else if (agencyType.sroId === SRO.DOSBG && val.stateCountryCode !== '1900') {
          this.emptyOriginTypeErrors();
          this.agencyError = true;
          this.agencyErrorMessage = `SRO ID DOSBG should have origin Belgium`;
          // "SRO = ""DOSBG"" and Destination not one of( ""AL00"".....)"
        } else if (HhgCarrierRateFilingComponent.internationalOriginAgencyCondition(val) && agencyType.sroId === SRO.DOSBG) {
          this.emptyOriginTypeErrors();
          this.agencyError = true;
          this.agencyErrorMessage = `SRO ID DOSBG should have destination CONUS`;
        } else {
          this.emptyOriginTypeErrors();
          this.emptyAgencyTypeErrors();
        }
        this.checkRateRecordInProcureTable();
        this.showDiscountFieldsAlaskaText = true;
        this.showDiscountFieldsText = false;
        this.destinationByTransport();
        break;
      case TST.INTRASTATE:
        // TODO if Origin not in TSP's scope of opearion
        // SRO = NAVDD and (canada-code or alaska-code)
        this.hhgCarrierRates.get('destinationId').setValue(val);
        if (agencyType.sroId === SRO.NAVDD && (HhgCarrierRateFilingComponent.canadaStatesCodeCondition(val) ||
          HhgCarrierRateFilingComponent.alaskaStateExclCodesCondition(val))) {
          this.originError = true;
          this.originErrorMessage = 'Invalid Origin/Destination for NAVDD';
        } else {
          this.emptyOriginTypeErrors();
          this.emptyAgencyTypeErrors();
        }
        this.checkRateRecordInProcureTable();
        if (HhgCarrierRateFilingComponent.alaskaStateExclCodesCondition(val)) {
          this.showDiscountFieldsAlaskaText = true;
          this.showDiscountFieldsText = false;
        } else {
          this.hhgCarrierRates.get('destinationId').disable();
          this.showDiscountFieldsText = true;
          this.showDiscountFieldsAlaskaText = false;
        }
        (HhgCarrierRateFilingComponent.alaskaStateCodesCondition(val))
          ? this.assignUabError() : this.clearUabError();
        break;
      default:
        this.emptyOriginTypeErrors();
        this.emptyAgencyTypeErrors();
        break;
    }
  }

  /**
   * @description handles destination value change event.
   */
  destinationTypeChange() {
    this.emptyDestinationTypeErrors();
    const transportType = this.getFormField('transportType').value;
    const agencyType = this.getFormField('sroMasterId').value;
    const rateType = this.getFormField('rateTypeId').value;
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    this.resetDiscounts();
    switch (transportType) {
      case TST.INTERSTATE:
        // SRO = NAVDD and (CANADA-ORIG-OR-DEST or ALASKAN-ORIG-OR-DEST)	Invalid Origin/Destination for the selected Agency
        if (agencyType.sroId === SRO.NAVDD &&
          ((HhgCarrierRateFilingComponent.alaskaStateCodesCondition(origin) || HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination)) ||
            HhgCarrierRateFilingComponent.canadaStatesCodeCondition(origin) || HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination))) {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Origin/Destination for the selected Agency';
          // (SRO = CCNTL or EXSTG or XSARC) and (Canada is origin or destination)
        } else if ((agencyType.sroId === SRO.CCNTL || agencyType.sroId === SRO.EXSTG || agencyType.sroId === SRO.XSARC) &&
          (HhgCarrierRateFilingComponent.canadaStatesCodeCondition(origin) || HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination))) {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Origin/Destination for the selected Agency';
          // Origin = "9700"	Invalid Int'l (Yugoslavia) Origin
        } else if (origin.stateCountryCode === '9700') {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Int\'l (Yugoslavia) Origin';
          // TODO SRO = CCNTL or EXSTG or XSARC ; check the scope of Destination and throw error if not in scope
          // SRO = DOSSA and Destination != (2570 and 5750 and 6250 and 8650 and 9900
        } else if (agencyType.sroId === SRO.DOSSA && (destination.stateCountryCode !== '2570' ||
          destination.stateCountryCode !== '5750' || destination.stateCountryCode !== '6250' ||
          destination.stateCountryCode !== '8650' || destination.stateCountryCode !== '9900')) {
          this.destinationError = true;
          this.destinationErrorMessage = 'DOSSA- Destination must be 2570, 5750, 6250, 8650 or 9900';
          // SRO = OCCDC and Destination =(Alaska Code OR Canada Code OR Contiguous State or 925L
        } else if (agencyType.sroId === SRO.OCCDC &&
          (destination.stateCountryCode !== '925L' && !HhgCarrierRateFilingComponent.continuousStatesCodeCondition(destination) &&
            !HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination) && !HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination))) {
          this.destinationError = true;
          this.destinationErrorMessage = 'OCCDC-Destination must be Domestic states or 925L';
        } else if (origin.stateCountryName.includes('CANADA') && destination.stateCountryName.includes('CANADA')) {
          this.destinationError = true;
          this.destinationErrorMessage = `Both origin and destination shouldn't be Canada`;
        } else {
          this.emptyDestinationTypeErrors();
          this.checkRateRecordInProcureTable();
        }
        (HhgCarrierRateFilingComponent.alaskaStateCodesCondition(origin) ||
          HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination) ||
          HhgCarrierRateFilingComponent.canadaStatesCodeCondition(origin) ||
          HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination)
        )
          ? this.assignUabError() : this.clearUabError();
        if ((HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination)) ||
          (this.showDiscountFieldsAlaskaText)) {
          this.showDiscountFieldsAlaskaText = true;
          this.showDiscountFieldsText = false;
        } else {
          this.showDiscountFieldsText = true;
          this.showDiscountFieldsAlaskaText = false;
        }
        break;
      case TST.INTERNATIONAL:
        // Destination = "9700"	Invalid Int'l (Yugoslavia) Dest
        if (destination.stateCountryCode === '9700') {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Int\'l (Yugoslavia) Dest';
          // TODO SRO =  ("CCNTL" or "EXSTG" or "XSARC") and Destination not in scope	Service Areas not allowed for Extended Storage
          // SRO = "DOSSA"  and  Destination !=  (2570"  or "5750"  or "6250" or  "8650" or  "9900")
        }  else if ((agencyType.sroId === SRO.CCNTL || agencyType.sroId === SRO.EXSTG ||
          agencyType.sroId === SRO.XSARC) && destination.stateCountryCode !== '0000') {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Int\'l (Yugoslavia) Dest';
        } else if ((destination.stateCountryCode !== '925L' && !HhgCarrierRateFilingComponent.continuousStatesCodeCondition(destination)
            && !HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination) && !HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination)) &&
          agencyType.sroId === SRO.OCCDC) {
          this.destinationError = true;
          this.destinationErrorMessage = 'OCCDC-Destination must be Domestic states or 925L';
          // SRO =  ("CCNTL" or "EXSTG" or "XSARC")  and Origin !=   (ALASKA-ST-CODES-EXCL-AK00 or VALID-CONTIGUOUS-ST)
        }  else if (agencyType.sroId === SRO.DOSMM && HhgCarrierRateFilingComponent.dosmmOrgDestSameValCondition(origin, destination)) {
          this.destinationError = true;
          this.destinationErrorMessage = 'DOSMM- Country to Country/State to State lanes are not allowed.';
        } else {
          this.emptyDestinationTypeErrors();
          this.checkRateRecordInProcureTable();
        }
        this.showDiscountFieldsAlaskaText = true;
        this.showDiscountFieldsText = false;
        break;
      case TST.INTRASTATE:
        // SRO = NAVDD and (canada-code or alaska-code)	Invalid Origin/Destination for NAVDD
        if (agencyType.sroId === SRO.NAVDD &&
          (HhgCarrierRateFilingComponent.canadaStatesCodeCondition(destination) || HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination))) {
          this.destinationError = true;
          this.destinationErrorMessage = 'Invalid Origin/Destination for NAVDD';
        } else {
          this.emptyDestinationTypeErrors();
          this.checkRateRecordInProcureTable();
        }
        if (HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination) && HhgCarrierRateFilingComponent.alaskaStateCodesCondition(origin)) {
          this.showDiscountFieldsAlaskaText = true;
          this.showDiscountFieldsText = false;
        } else {
          this.showDiscountFieldsText = true;
          this.showDiscountFieldsAlaskaText = false;
        }
        break;
      default:
        this.emptyDestinationTypeErrors();
        break;
    }
  }

  getRateTypeBasedOnMCAndFF(transportationType: number){
    this.messageForMCAndFF = "";
    switch(this.isMCFFAvailable){
      case 3: //MC and FF
        if(transportationType === 1){
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return (x.transportationType === TT.DOMESTIC || x.transportationType === TT.EXTENDEDSTORAGE) && x.businessType === BT.HHG ;
          });
        }else{
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return x.transportationType === TT.DOMESTIC && x.businessType === BT.HHG;
          });
        }
        break;
      case 2: //only FF
        if(transportationType === 1){
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return (x.transportationType === TT.DOMESTIC || x.transportationType === TT.EXTENDEDSTORAGE) && x.businessType === BT.HHG &&
              ([3,4,11,14,15].find(y => y === x.rateTypeId));
          });
        }else{
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return x.transportationType === TT.DOMESTIC && x.businessType === BT.HHG && ([3,4,11,14,15].find(y => y === x.rateTypeId));
          });
        }

        break;
      case 1: //only MC
        if(transportationType === 1){
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return (x.transportationType === TT.DOMESTIC || x.transportationType === TT.EXTENDEDSTORAGE) && x.businessType === BT.HHG;
          });
        }else{
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return x.transportationType === TT.DOMESTIC && x.businessType === BT.HHG;
          });
        }
        break;
      case 0: //no MC or FF
        if(transportationType === 1){
          this.rateTypesByTransport = this.rateTypes.filter(x => {
            return x.transportationType === TT.EXTENDEDSTORAGE && x.businessType === BT.HHG;
          });
        }else{
          this.messageForMCAndFF = "No Rate Type For Adding Rate"
          return null;
        }
        break;
      default:
        break;
      // return (x.transportationType === TT.DOMESTIC || x.transportationType === TT.EXTENDEDSTORAGE) && x.businessType === BT.HHG ;
    }
  }


  /**
   * @description filters rate types whose transportation type is interstate
   */
  rateTypesInterstate() {
    if (this.rateTypes !== null && this.rateTypes !== undefined && this.rateTypes.length > 0) {
      this.getRateTypeBasedOnMCAndFF(1);
    }
  }

  /**
   * @description filters rate types whose transportation type is intrastate
   */
  rateTypesIntrastate() {
    if (this.rateTypes !== null && this.rateTypes !== undefined && this.rateTypes.length > 0) {
      this.getRateTypeBasedOnMCAndFF(2);
    }
  }

  /**
   * @description filters rate types whose transportation type is international
   */
  rateTypesInternational() {
    if (this.rateTypes !== null && this.rateTypes !== undefined && this.rateTypes.length > 0) {
      this.rateTypesByTransport = this.rateTypes.filter(x => {
        return x.transportationType === TT.INTERNATIONAL && x.businessType === BT.HHG;
      });
    }
  }

  /**
   * @description populates origin dropdown based on transport type
   */
  originByTransport() {
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    const agencyType = this.getFormField('sroMasterId').value;
    this.isVehicleMandatory = true;
    if (this.stateCountries !== null && this.stateCountries !== undefined && this.stateCountries.length > 0) {
      switch (transportType) {
        case TST.INTERSTATE:
          if (rateType && rateType === 11) {
            this.originByType = this.stateCountries.filter(x => {
              return ((x.stateCountryType === stateCountry.STATE) &&
                ((x.stateCountryCode !== 'HI') &&
                  (x.stateCountryCode !== 'LB' ) &&
                  (x.stateCountryCode !== 'NF') &&
                  (x.stateCountryCode !== 'AK') &&
                  (x.stateCountryCode !== 'PR') && (x.parentCountryId !== 365)));
            });
          } else {
            this.originByType = this.stateCountries.filter(x => {
              return ((x.stateCountryType === stateCountry.STATE) &&
                ((x.stateCountryCode !== 'HI') &&
                  (x.stateCountryCode !== 'LB' ) &&
                  (x.stateCountryCode !== 'NF') &&
                  (x.stateCountryCode !== 'AK') &&
                  (x.stateCountryCode !== 'PR')));
            });
          }
          break;
        case TST.INTERNATIONAL:
          this.stateCountries = this.stateCountries.filter(x => {
            return((x.stateCountryCode !== '925E') && x.stateCountryCode !== 'US00' && (x.stateCountryCode !== '925S') && (x.stateCountryCode !== 'CA00') && (x.stateCountryCode !== 'AK') && x.stateCountryType !== 'Zone');
          });
          if (rateType === 9 || rateType === 10) {
            this.originByType = this.stateCountries.filter(x => {
              return ((x.stateCountryCode !== '9700' && x.stateCountryType === stateCountry.STATE) ||
                (x.stateCountryType === stateCountry.STATE && x.deptOfState === true));
            });
          } else if (agencyType.sroId === SRO.DOSHW) {
            this.originByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode === stateCodes.MD);
            });
            this.isVehicleMandatory = false;
            this.clearUabError();
            this.hhgCarrierRates.get('classVehicle1').clearValidators();
            this.hhgCarrierRates.get('classVehicle2').clearValidators();
            this.hhgCarrierRates.get('classVehicle3').clearValidators();
          } else if (agencyType.sroId === SRO.OCCDC) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = OCCDC) and (state_country_type = "S" or state_country_code="925L)  populate state/country.
            this.originByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode !== stateCodes.LB && x.stateCountryCode !== stateCodes.NF && x.stateCountryCode !== '9700' &&
                x.stateCountryType !== stateCountry.SERVICEAREA && x.stateCountryCode !== 'US00');
            });
          } else if (agencyType.sroId !== SRO.DOSSA && agencyType.sroId !== SRO.DOSMM) {
            //  (if state_country_code != (LB00 or NF00 or 9700) and (if SRO != DOSSA)   populate state/country.
            this.originByType = this.stateCountries.filter(x => {
              return ((x.stateCountryCode !== stateCodes.LB && x.stateCountryCode !== stateCodes.NF && x.stateCountryCode !== '9700') &&
                (x.stateCountryType === stateCountry.STATE || x.stateCountryType === stateCountry.COUNTRY));
            });
          } else if (agencyType.sroId === SRO.DOSSA) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = DOSSA and (state_country_code=DC00 or MD00 or VA00))  populate state/country.
            this.originByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC);
            });
          } else if (agencyType.sroId === SRO.DOSMM) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = DOSMM and (state_country_code=DC00 or MD00 or VA00))  populate state/country.
            this.originByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC
              || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
              || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
              || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
            });
          } else {
            this.originByType = [];
          }
          break;
        case TST.INTRASTATE:
          this.originByType = this.stateCountries.filter(x => {
            return ((x.stateCountryType === stateCountry.STATE) &&
              (x.stateCountryCode !== 'AB' && x.stateCountryCode !== 'AK' &&
                x.stateCountryCode !== 'BC' && x.stateCountryCode !== 'LB' &&
                x.stateCountryCode !== 'MB' && x.stateCountryCode !== 'NB' &&
                x.stateCountryCode !== 'NF' && x.stateCountryCode !== 'NL' &&
                x.stateCountryCode !== 'NS' && x.stateCountryCode !== 'HI' &&
                x.stateCountryCode !== 'NT' && x.stateCountryCode !== 'ON' &&
                x.stateCountryCode !== 'PE' && x.stateCountryCode !== 'PQ' &&
                x.stateCountryCode !== 'SK' && x.stateCountryCode !== 'YT' &&
                x.stateCountryCode !== 'PR' && x.stateTariffUse !== 1 && x.stateCountryCode !== stateCodes.AN &&
                x.stateCountryCode !== stateCodes.CV && x.stateCountryCode !== stateCodes.FB && x.stateCountryCode !== stateCodes.JN &&
                x.stateCountryCode !== stateCodes.KN && x.stateCountryCode !== stateCodes.KD && x.stateCountryCode !== stateCodes.PB &&
                x.stateCountryCode !== stateCodes.SA &&
                x.stateCountryCode !== stateCodes.WG
              ));
          });
          break;
        default:
          this.originByType = [];
          break;
      }
    } else {
      this.alertService.error('Unable to load state, countries list at this moment. Please try again after sometime or contact your system administrator.');
    }
  }

  /**
   * @description populates destination list by agency type and rate type.
   */
  destinationByTransport() {
    this.showCode = false;
    const transportType = this.getFormField('transportType').value;
    const agencyType = this.getFormField('sroMasterId').value;
    const rateType = this.getFormField('rateTypeId').value;
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    if (this.stateCountries !== null && this.stateCountries !== undefined && this.stateCountries.length > 0) {
      switch (transportType) {
        // Don't populate anything for type 11. For all other types populate from Service Area.
        case TST.INTERSTATE:
          this.showCode = true;
          if (rateType === 11) {
            this.destinationByType = [];
          } else if ((rateType !== null && rateType !== undefined && rateType !== '')) {
            this.destinationByType = this.stateCountries.filter(x => {
              return ((x.stateCountryType === stateCountry.SERVICEAREA) &&
                (x.stateCountryCode !== '0000') &&
                (x.stateCountryCode !== '2302' ) &&
                (x.stateCountryCode !== '2305'));
            });
            this.destinationByType.sort((a, b) => {
              return a.stateCountryCode < b.stateCountryCode ? -1 : 1;
            });
          } else {
            this.destinationByType = [];
          }
          break;
        case TST.INTERNATIONAL:
          this.destinationByType = this.stateCountries.filter(x => x.stateCountryCode !== 'US00');
          this.destinationByType = this.destinationByType.filter(x => {
            return((x.stateCountryCode !== '925E') && (x.stateCountryCode !== '925S') && (x.stateCountryCode !== 'CA00') && (x.stateCountryCode !== 'AK'));
          });
          if (origin.stateCountryType == 'State') {
            this.destinationByType = this.destinationByType.filter(x => {
              return (x.stateCountryType !== 'State' );
            });
          }
          if (rateType === 9 || rateType === 10) {
            this.destinationByType = this.destinationByType.filter(x => {
              return ((x.stateCountryCode !== '9700' && x.stateCountryType === stateCountry.STATE) ||
                (x.stateCountryType === stateCountry.STATE && x.deptOfState === true));
            });
          } else if (agencyType.sroId === SRO.DOSHW) {
            this.destinationByType = this.stateCountries.filter(x => {
              return (x.parentCountryId !== 326 && x.stateCountryType !== 'Zone' && x.parentCountryId !== 365);
            });
          } else if (agencyType.sroId === SRO.OCCDC) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = OCCDC) and (state_country_type = "S" or state_country_code="925L)  populate state/country.
            this.destinationByType = this.destinationByType.filter(x => {
              return (x.stateCountryCode !== stateCodes.LB && x.stateCountryCode !== stateCodes.NF && x.stateCountryCode !== '9700' &&
                x.stateCountryType !== stateCountry.SERVICEAREA && x.stateCountryCode !== 'US00');
            });
          } else if (agencyType.sroId !== SRO.DOSSA && agencyType.sroId !== SRO.DOSMM) {
            //  (if state_country_code != (LB00 or NF00 or 9700) and (if SRO != DOSSA)   populate state/country.
            this.destinationByType = this.destinationByType.filter(x => {
              return ((x.stateCountryCode !== stateCodes.LB && x.stateCountryCode !== stateCodes.NF && x.stateCountryCode !== '9700') &&
                (x.stateCountryType === stateCountry.STATE || x.stateCountryType === stateCountry.COUNTRY));
            });
          } else if (agencyType.sroId === SRO.DOSSA) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = DOSSA and (state_country_code=DC00 or MD00 or VA00))  populate state/country.
            this.destinationByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode === '5250' || x.stateCountryCode === '108E' ||
                x.stateCountryCode ===  '8650'  || x.stateCountryCode === '1410'  || x.stateCountryCode === '9900'  || x.stateCountryCode === '112A'  ||
                x.stateCountryCode === '5050'  || x.stateCountryCode === '5850'  ||
                x.stateCountryCode === '130N'  || x.stateCountryCode === '2320'  || x.stateCountryCode === '9270'  || x.stateCountryCode === '121K'  ||
                x.stateCountryCode === '2520'  || x.stateCountryCode === '117U'  || x.stateCountryCode === '136T'  || x.stateCountryCode === '109G'  || x.stateCountryCode === '8350'  ||
                x.stateCountryCode === '8210'  || x.stateCountryCode === '5770'  || x.stateCountryCode === '101A' || x.stateCountryCode === '5750' || x.stateCountryCode === '6700' ||
              x.stateCountryCode === '3350'  || x.stateCountryCode === '8180'  || x.stateCountryCode === '6250');
            });
          }  else if (agencyType.sroId === SRO.DOSMM) {
            // (if state_country_code != (LB00 or NF00 or 9700) and (if SRO = DOSMM and (state_country_code=DC00 or MD00 or VA00))  populate state/country.
            this.destinationByType = this.stateCountries.filter(x => {
              return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC
                || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
                || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
                || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
            });
          } else {
            this.destinationByType = [];
          }
          break;
        // Populate all states in Origin dropdown from state_country table with STATE_COUNTRY_TYPE="state"
        case TST.INTRASTATE:
          if (rateType === null || rateType === undefined || rateType === '') {
            this.destinationByType = [];
          } else {
            this.destinationByType = this.stateCountries.filter(x => {
              return ((x.stateCountryType === stateCountry.STATE) &&
                (
                  x.stateCountryCode !== 'AB' && x.stateCountryCode !== 'AK' &&
                  x.stateCountryCode !== 'BC' && x.stateCountryCode !== 'LB' &&
                  x.stateCountryCode !== 'MB' && x.stateCountryCode !== 'NB' &&
                  x.stateCountryCode !== 'NF' && x.stateCountryCode !== 'NL' &&
                  x.stateCountryCode !== 'NS' &&
                  x.stateCountryCode !== 'NT' && x.stateCountryCode !== 'ON' &&
                  x.stateCountryCode !== 'PE' && x.stateCountryCode !== 'PQ' &&
                  x.stateCountryCode !== 'SK' && x.stateCountryCode !== 'YT' &&
                  x.stateTariffUse !== 1
                ));
            });
          }
          break;
        default:
          this.destinationByType = [];
          break;
      }
    } else {
      this.alertService.error('Unable to load state, countries list at this moment. Please try again after sometime or contact your system administrator.');
    }
  }

  /**
   * @description filter agencies when the transport type is interstate
   * @param val ratetype id
   * @param transportType
   */
  filterAgenciesByRates(val, transportType) {
    switch (val) {
      case 1:
        transportType === TST.INTERSTATE ? this.filterAgencyBy1() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy1() : console.log();
        break;
      case 2:
        transportType === TST.INTERSTATE ? this.filterAgencyBy2() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy2() : console.log();
        break;
      case 3:
        transportType === TST.INTERSTATE ? this.filterAgencyBy1() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy1() : console.log(' not found');
        break;
      case 4:
        transportType === TST.INTERSTATE ? this.filterAgencyBy4() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy4() : console.log();
        break;
      case 5:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgencyBy1() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 6:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgency11() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 7:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgencyBy1() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 8:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgency9() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 9:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgency12() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 10:
        transportType === TST.INTERSTATE ? console.log() : transportType === TST.INTERNATIONAL ? this.filterAgency13() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 11:
        transportType === TST.INTERSTATE ? this.filterAgency5() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? console.log() : console.log();
        break;
      case 12:
        transportType === TST.INTERSTATE ? this.filterAgencyBy1() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy1() : console.log();
        break;
      case 13:
        transportType === TST.INTERSTATE ? this.filterAgencyBy2() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy2() : console.log();
        break;
      case 14:
        transportType === TST.INTERSTATE ? this.filterAgencyBy1() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy1() : console.log();
        break;
      case 15:
        transportType === TST.INTERSTATE ? this.filterAgencyBy4() : transportType === TST.INTERNATIONAL ? console.log() : transportType === TST.INTRASTATE ? this.filterAgencyBy4() : console.log();
        break;
      default:
        this.agenciesByRateType = this.agencies;
        break;
    }
  }

  filterAgencyByRateType(rateType: any) {
    this.rateTypesSroList = [];
    for (const agency of this.agencies){
      this.rateTypesSroList = agency.rateTypesSroEntity;
      for (const rateTypeSro of  this.rateTypesSroList){
        if (rateType === rateTypeSro.rateTypeId) {
          this.agenciesByRateType.push(agency);
        }
      }
    }
  }

  filterAgencyBy1() {
    this.agenciesByRateType = this.agencies.filter(x => {
      return x.sroId === SRO.GENRL;
    });
  }

  filterAgencyBy2() {
    this.agenciesByRateType = this.agenciesInterstate.filter(x => {
      return x.sroId !== SRO.XSARC && x.sroId !== SRO.EXSTG && x.sroId !== SRO.CCNTL && x.sroId !== SRO.CONDI && x.sroId !== SRO.GENRL;
    });
  }

  filterAgencyBy4() {
    this.agenciesByRateType = this.agenciesInterstate.filter(x => {
      return x.sroId !== SRO.USPDC && x.sroId !== SRO.OCCDC && x.sroId !== SRO.SSADI && x.sroId !== SRO.ARCWV
        && x.sroId !== SRO.XSARC && x.sroId !== SRO.EXSTG && x.sroId !== SRO.CCNTL
        && x.sroId !== SRO.DOSDD && x.sroId !== SRO.DEADD && x.sroId !== SRO.GENRL;
    });
  }

  filterAgency5() {
    this.agenciesByRateType = this.agenciesInterstate.filter(x => {
      return x.sroId === SRO.CCNTL || x.sroId === SRO.XSARC || x.sroId === SRO.EXSTG;
    });
  }

  filterAgency9() {
    this.agenciesByRateType = this.agenciesInternational.filter(x => {
      return x.sroId !== SRO.DOSDC && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSUS &&
        x.sroId !== SRO.DOSHW && x.sroId !== SRO.DOSSA && x.sroId !== SRO.DOSAS && x.sroId !== SRO.DOSUS
        && x.sroId !== SRO.USPDC && x.sroId !== SRO.OCCDC && x.sroId !== SRO.ARCWV &&
        x.sroId !== SRO.SSADI && x.sroId !== SRO.GENRL;
    });
  }

  filterAgency11() {
    this.agenciesByRateType = this.agenciesInternational.filter(x => {
      return x.sroId !== SRO.DOSUS && x.sroId !== SRO.DOSAS && x.sroId !== SRO.GENRL;
    });
  }

  filterAgency12() {
    this.agenciesByRateType = this.agenciesInternational.filter(x => {
      return x.sroId !== SRO.USPDC && x.sroId !== SRO.DOSAS && x.sroId !== SRO.CONDI &&
        x.sroId !== SRO.OCCDC && x.sroId !== SRO.ARCWV && x.sroId !== SRO.SSADI;
    });
  }

  filterAgency13() {
    this.agenciesByRateType = this.agenciesInternational.filter(x => {
      return x.sroId !== SRO.USPDC && x.sroId !== SRO.DOSUS && x.sroId !== SRO.CONDI &&
        x.sroId !== SRO.OCCDC && x.sroId !== SRO.ARCWV && x.sroId !== SRO.SSADI &&
        x.sroId !== SRO.GENRL;
    });
  }

  filterAgency14() {
    this.agenciesByRateType = this.agenciesIntrastate.filter(x => {
      return x.sroId !== SRO.FAAIN && x.sroId !== SRO.DOSDC && x.sroId !== SRO.FAADC &&
        x.sroId !== SRO.NOAAA && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSHW &&
        x.sroId !== SRO.DOSSA && x.sroId !== SRO.NBCCO && x.sroId !== SRO.GEOVA &&
        x.sroId !== SRO.FSVNM && x.sroId !== SRO.DOSBG && x.sroId !== SRO.CONDI;
    });
  }

  filterAgency15() {
    this.agenciesByRateType = this.agenciesIntrastate.filter(x => {
      return x.sroId !== SRO.FAAIN && x.sroId !== SRO.DOSDC && x.sroId !== SRO.FAADC &&
        x.sroId !== SRO.NOAAA && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSHW &&
        x.sroId !== SRO.DOSSA && x.sroId !== SRO.NBCCO && x.sroId !== SRO.GEOVA &&
        x.sroId !== SRO.FSVNM && x.sroId !== SRO.DOSBG && x.sroId !== SRO.DOSDD && x.sroId !== SRO.DEADD && x.sroId !== SRO.USPDC &&
        x.sroId !== SRO.OCCDC && x.sroId !== SRO.SSADI && x.sroId !== SRO.ARCWV && x.sroId !== SRO.GENRL;
    });
  }

  /**
   * @description clears all the rate type errors
   */
  emptyRateTypeErrors() {
    this.rateTypeError = false;
    this.rateTypeErrorMessage = [];
  }

  /**
   * @description clears all the agency type errors
   */
  emptyAgencyTypeErrors() {
    this.agencyError = false;
    this.agencyErrorMessage = '';
  }

  /**
   * @description clears all the origin type errors
   */
  emptyOriginTypeErrors() {
    this.originError = false;
    this.originErrorMessage = '';
  }

  /**
   * @description clears all the destination type errors
   */
  emptyDestinationTypeErrors() {
    this.destinationError = false;
    this.destinationErrorMessage = '';
  }

  emptyDestinationTypeProcureErrors() {
    this.destinationProcureError = false;
    this.destinationProcureErrorMessage = '';
  }

  /**
   * @description empties rate types
   */
  emptyRateTypesByTransport() {
    this.rateTypesByTransport = [];
  }

  /**
   * @description empties origin types
   */
  emptyOriginByType() {
    this.originByType = [];
  }

  /**
   * @description empties destination types
   */
  emptyDestinationByType() {
    this.destinationByType = [];
  }

  categoryVehicleSetValidators() {
    this.isVehicleMandatory = true;
    this.getFormField('classVehicle1').setValidators([Validators.required]);
    this.getFormField('classVehicle2').setValidators([Validators.required]);
    this.getFormField('classVehicle3').setValidators([Validators.required]);
  }

  categoryVehicleClearValidators() {
    this.isVehicleMandatory = false;
    this.getFormField('classVehicle1').clearValidators();
    this.getFormField('classVehicle2').clearValidators();
    this.getFormField('classVehicle3').clearValidators();
  }

  /**
   * @description show/hide discount section fields based in the transport type and rate type.
   */
  showDiscountFieldsByType() {
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    const agencyType = this.getFormField('sroMasterId').value;
    this.categoryVehicleSetValidators();
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    this.showDiscountFieldsText = false;
    this.showDiscountFieldsAlaskaText = false;
    switch (transportType) {
      case TST.INTERSTATE:
        if (rateType !== null && rateType !== undefined && rateType !== '') {
          if (rateType === 11) {
            this.showDiscountFieldsByRate = true;
            this.showDiscountFieldsByTransport = false;
            this.categoryVehicleClearValidators();
            this.getFormField('linehaul').clearValidators();
          } else {
            this.getFormField('linehaul').setValidators([Validators.required, Validators.pattern('^[\-0-9]+(.[0-9]{0,100})?$')]);
            this.showDiscountFieldsByRate = false;
            this.showDiscountFieldsByTransport = true;
          }
        } else {
          this.getFormField('linehaul').setValidators([Validators.required, Validators.pattern('^[\-0-9]+(.[0-9]{0,100})?$')]);
          this.showDiscountFieldsByTransport = true;
          this.showDiscountFieldsByRate = false;
        }
        break;
      case TST.INTERNATIONAL:
        if (agencyType.sroId === SRO.DOSHW) {
          this.categoryVehicleClearValidators();
        } else {
          this.categoryVehicleSetValidators();
        }
        this.showDiscountFieldsByRate = false;
        this.showDiscountFieldsByTransport = true;
        this.showDiscountFieldsAlaskaText = true;
        break;
      case TST.INTRASTATE:
        this.showDiscountFieldsByRate = false;
        this.showDiscountFieldsByTransport = true;
        this.showDiscountFieldsText = true;
        break;
      default:
        this.showDiscountFieldsByTransport = true;
        this.showDiscountFieldsByRate = false;
        if (HhgCarrierRateFilingComponent.alaskaStateCodesCondition(origin) ||
          HhgCarrierRateFilingComponent.alaskaStateCodesCondition(destination)) {
          this.showDiscountFieldsAlaskaText = true;
        } else {
          this.showDiscountFieldsText = true;
        }
        break;
    }

  }

  /**
   * @description executes whenever there is a value change for packaging, warehouse handling and monthly storage.
   * @param val input value
   * @param field type of field
   */
  packagingDiscountValueChange(val, field) {
    field === 'packaging' ? (this.emptyPackagingDiscountError(), this.emptyPackagingDiscountWarning()) :
      field === 'warehouse' ? (this.emptyWarehouseError(), this.emptyWarehouseWarning()) :
        field === 'storage' ? (this.emptyMonthlyStorageError(), this.emptyMonthlyStorageWarning()) : console.log();
    if (val.indexOf('.') > -1) {
      field === 'packaging' ? (this.packagingDiscountError = true, this.packagingDiscountErrorMessage = `Pkng/Loading/Drayage charge should be a whole number`) :
        field === 'warehouse' ? (this.wareHouseError = true, this.wareHouseErrorMessage = `Warehouse handling charge should be a whole number`) :
          field === 'storage' ? (this.monthlyStorageError = true, this.monthlyStorageErrorMessage = `Monthly Storage charge should be a whole number`) : console.log();
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    switch (transportType) {
      case TST.INTERSTATE:
        if (rateType !== null && rateType !== undefined && rateType !== '') {
          // if rate type = 11  and  this field value = zero
          if (rateType === 11 && val / 100 === 0) {
            field === 'packaging' ? (this.packagingDiscountError = true, this.packagingDiscountErrorMessage = `Pkng/Loading/Drayage charge cannot be 0 or blank`) :
              field === 'warehouse' ? (this.wareHouseError = true, this.wareHouseErrorMessage = `Warehouse handling charge cannot be 0 or blank`) :
                field === 'storage' ? (this.monthlyStorageError = true, this.monthlyStorageErrorMessage = `Monthly Storage charge cannot be 0 or blank`) : console.log();
            // if rate type = 11 and this value  > $99.00
          } else if (rateType === 11 && val / 100 > 99.00) {
            field === 'packaging' ? (this.packagingDiscountWarning = true, this.packagingDiscountWarningMessage = `Suspect records - Pkng/Loading/Drayage rate > $99.00.`) :
              field === 'warehouse' ? (this.wareHouseWarning = true, this.wareHouseWarningMessage = `Suspect records - Warehouse handling rate > $99.00.`) :
                field === 'storage' ? (this.monthlyStorageWarning = true, this.monthlyStorageWarningMessage = `Suspect records - Monthly Storage rate > $99.00. `) : console.log();
          }/* else {
            this.emptyPackagingDiscountError();
          }*/
        }/* else {
          this.emptyPackagingDiscountError();
        }*/
        break;
      case TST.INTERNATIONAL:
        this.emptyPackagingDiscountError();
        this.emptyWarehouseError();
        this.emptyMonthlyStorageError();
        this.emptyPackagingDiscountWarning();
        this.emptyWarehouseWarning();
        this.emptyMonthlyStorageWarning();
        break;
      case TST.INTRASTATE:
        this.emptyPackagingDiscountError();
        this.emptyWarehouseError();
        this.emptyMonthlyStorageError();
        this.emptyPackagingDiscountWarning();
        this.emptyWarehouseWarning();
        this.emptyMonthlyStorageWarning();
        break;
      default:
        this.emptyPackagingDiscountError();
        this.emptyWarehouseError();
        this.emptyMonthlyStorageError();
        this.emptyPackagingDiscountWarning();
        this.emptyWarehouseWarning();
        this.emptyMonthlyStorageWarning();
        break;
    }
  }

  /**
   * @description executes whenever there is a value change in transportation %
   * @param val: transportation % input value
   */
  transportationValueChange(val) {
    this.emptyTransportationError();
    this.emptyTransportationWarning();
    if (val.indexOf('.') > -1) {
      this.transportationError = true;
      this.transportationErrorMessage = `The Linehaul Discount % should be a whole number`;
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    switch (transportType) {
      case TST.INTERSTATE:
      /*        if (val < 0) {
                this.transportationWarning = true;
                this.transportationWarningMessage = `Suspected records - Value negative`;
              } else {
                this.emptyTransportationError();
                this.emptyTransportationWarning();
              }
              break;*/
      case TST.INTRASTATE:
        // if value = Zero
        if (val === 0) {
          this.transportationError = true;
          this.transportationErrorMessage = `Linehaul Discount % cannot be 0 or blank`;
          // if Value > 100
        } else if (val > 100) {
          this.transportationError = true;
          this.transportationErrorMessage = `The Linehaul Discount % cannot be greater than 100`;
          // if Value > 60
        } else if (val > 60) {
          this.transportationWarning = true;
          this.transportationWarningMessage = `Suspected records - Domestic Rates Discounted over 60%.`;
        } else if (val < 0) {
          this.transportationWarning = true;
          this.transportationWarningMessage = `Suspected records - Value negative`;
        } else {
          this.emptyTransportationError();
          this.emptyTransportationWarning();
        }
        break;
      case TST.INTERNATIONAL:
        // (type=9 or 10) and value > " "
        if ((rateType === 9 || rateType === 10) && val > 0) {
          this.transportationError = true;
          this.transportationErrorMessage = `Rate Type 9 and10 should not have Linehaul Discount %`;
          // type!=(9 or 10) and value = " "
        } else if ((rateType !== 9 && rateType !== 10) && val === 0) {
          this.transportationError = true;
          this.transportationErrorMessage = `Linehaul Discount % cannot be 0`;
        } else if (val < 0) {
          this.transportationError = true;
          this.transportationErrorMessage = `Linehaul Discount % cannot be negative`;
        } else {
          this.emptyTransportationError();
          this.emptyTransportationWarning();
        }
        break;
      default:
        this.emptyTransportationError();
        this.emptyTransportationWarning();
        break;
    }
  }

  /**
   * @description executes whenever there is a value change in storage in transit
   * @param val: tranportation % input value
   */
  sitValueChange(val) {
    this.emptySitWarning();
    this.emptySitError();
    if (val.indexOf('.') > -1) {
      this.sitError = true;
      this.sitErrorMessage = `Storage In transit should be a whole number`;
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    switch (transportType) {
      case TST.INTERSTATE:
      /*        if (val < 0) {
                this.sitWarning = true;
                this.sitWarningMessage = `Suspect records - Value Negative.`;
              } else if (val === 0) {
                this.sitError = true;
                this.sitErrorMessage = `Value cannot be 0 or blank`;
                // if Value > 100
              } else {
                this.emptySitWarning();
                this.emptySitError();
              }
              // (rateType !== 9 && rateType !== 10)
              break;*/
      case TST.INTRASTATE:
        // value = Zero
        if (val === 0 && rateType !== 11) {
          this.sitError = true;
          this.sitErrorMessage = `Storage In transit cannot be 0`;
          // if Value > 100
        } else if (val === 0 && rateType === 11) {
          this.sitError = true;
          this.sitErrorMessage = `Delivery within 50 miles cannot be 0`;
          // if Value > 100
        } else if (val > 100) {
          this.sitError = true;
          this.sitErrorMessage = `Storage In transit cannot be greater than 100`;
        } else if (val < 0) {
          this.sitWarning = true;
          this.sitWarningMessage = `Suspect records - Value Negative.`;
        } else {
          this.emptySitWarning();
          this.emptySitError();
        }
        break;
      case TST.INTERNATIONAL:
        // (type=9 or 10) and value > " "
        if ((rateType === 9 || rateType === 10) && val > 0) {
          this.sitError = true;
          this.sitErrorMessage = `SIT should be 0`;
          // type!=(9 or 10) and value = zero
        } else if ((rateType !== 9 && rateType !== 10) && val === 0) {
          this.sitError = true;
          this.sitErrorMessage = `SIT cannot be 0 or blank`;
        } else if (val < 0) {
          this.sitError = true;
          this.sitErrorMessage = `SIT cannot be negative`;
        } else {
          this.emptySitWarning();
          this.emptySitError();
        }
        break;
      default:
        this.emptySitWarning();
        this.emptySitError();
        break;
    }
  }

  /**
   * @description executes whenever there is a value change in accessory services
   * @param val: tranportation % input value
   */
  accSvcsValueChange(val) {
    if (val.indexOf('.') > -1) {
      this.accSvcsError = true;
      this.accSvcsErrorMessage = `Domestic ACCSRL should be a whole number`;
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    const agencyType = this.getFormField('sroMasterId').value;
    switch (transportType) {
      case TST.INTERSTATE:
      case TST.INTRASTATE:
        // (SRO != DOSHW) and value = Zero
        if (agencyType.sroId !== SRO.DOSHW && val !== 0 && rateType !== 11) {
          this.accSvcsError = true;
          this.accSvcsErrorMessage = `For Domestic ACCSRL should be 0 or blank`;
        } else if (val === 0 && rateType === 11) {
          this.accSvcsError = true;
          this.accSvcsErrorMessage = `Delivery Handling Out charge cannot be 0 or blank.`;
        } else {
          this.emptyAccSvcsError();
        }
        break;
      case TST.INTERNATIONAL:
        // (type=9 or 10) and value > " "
        if ((rateType === 9 || rateType === 10) && val > 0) {
          this.accSvcsError = true;
          this.accSvcsErrorMessage = `ACC SVCS should be 0`;
          // type!=(9 or 10) and value = zero
        } else if ((rateType !== 9 && rateType !== 10) && val === 0) {
          this.accSvcsError = true;
          this.accSvcsErrorMessage = `ACC SVCS cannot be 0 or blank`;
        } else {
          this.emptyAccSvcsError();
        }
        break;
      default:
        this.emptyAccSvcsError();
        break;
    }
  }

  /**
   * @description executes whenever there is a value change in UAB
   * @param val: discount fields input value
   */
  onDiscountFieldsChange(val, field) {
    field === 'delivery50Mile' ? (this.discountFieldSitError = false, this.discountFieldSitErrorMessage = '') :
      field === 'deliveryHandOut' ? (this.discountFieldMonthlyStorageError = false, this.discountFieldMonthlyStorageErrorMessage = '') : console.log();
    if (val.indexOf('.') > -1) {
      field === 'delivery50Mile' ? (this.discountFieldSitError = true, this.discountFieldSitErrorMessage = `Vehicle Rate for Category I should be a whole number`) :
        field === 'deliveryHandOut' ? (this.discountFieldMonthlyStorageError = true, this.discountFieldMonthlyStorageErrorMessage = `Vehicle Rate for Category II should be a whole number`) : console.log();
    } else if (val === '' || Number(val) === 0) {
      field === 'delivery50Mile' ? (this.discountFieldSitError = true, this.discountFieldSitErrorMessage = `Delivery within 50 miles charge cannot be 0 or blank.`) :
        field === 'deliveryHandOut' ? (this.discountFieldMonthlyStorageError = true, this.discountFieldMonthlyStorageErrorMessage = `Delivery Handling Out charge cannot be 0 or blank.`) : console.log();
    }
  }

  /**
   * @description executes whenever there is a value change in UAB
   * @param val: tranportation % input value
   */
  uabValueChange(val) {
    if (val.indexOf('.') > -1) {
      this.uabError = true;
      this.uabErrorMessage = `UAB should be a whole number`;
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    const agencyType = this.getFormField('sroMasterId').value;
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    switch (transportType) {
      case TST.INTERSTATE:
        // value = Zero and (Origin in (orgArray OR canOrgArray))
        if (val === 0 && (HhgCarrierRateFilingComponent.orgArrayConditionUab(origin) || HhgCarrierRateFilingComponent.canOrgArrayConditionUab(origin))) {
          this.uabError = true;
          this.uabErrorMessage = `UAB cannot be 0 for Alaskan/Canadian Origin`;
          // // value = Zero and (Destination in (orgArray or canOrgArray))
        } else if (val === 0 && (HhgCarrierRateFilingComponent.desArrayConditionUab(destination) || HhgCarrierRateFilingComponent.canDesArrayConditionUab(destination))) {
          this.uabError = true;
          this.uabErrorMessage = `UAB cannot be 0 for Alaskan/Canadian Destination`;
          // // value != Zero and ((origin not in orgArray) & (destination not in desArray) & (origin not in canOrgArray) & (origin not in canDesArray))
        } else if (val !== 0 && val > 0 && !HhgCarrierRateFilingComponent.orgArrayConditionUab(origin) &&
          !HhgCarrierRateFilingComponent.canOrgArrayConditionUab(origin) &&
          !HhgCarrierRateFilingComponent.canDesArrayConditionUab(destination) && !HhgCarrierRateFilingComponent.desArrayConditionUab(destination)) {
          this.uabError = true;
          this.uabErrorMessage = `For Non Alaskan/Canadian Origin/ Destination, UAB should be 0 or blank`;
        } else if (val < 0) {
          this.uabError = true;
          this.uabErrorMessage = 'UAB cannot be negative';
        } else {
          this.emptyUabError();
        }
        break;
      case TST.INTERNATIONAL:
        // (type=9 or 10) and value > " "
        if (agencyType.sroId === SRO.DOSHW && (val !== 0 && val !== '')) {
          this.clearUabError();
          this.uabError = true;
          this.uabErrorMessage = `UAB should be 0 or blank`;
          // type!=(9 or 10) and SRO=(DOSBG or DOSHW) and  value = zero
        } else if ((agencyType.sroId === SRO.DOSSA || agencyType.sroId === SRO.DOSMM) && val === 0) {
          this.uabError = true;
          this.uabErrorMessage = `UAB should not be 0`;
        } else if (val < 0) {
          this.uabError = true;
          this.uabErrorMessage = 'UAB cannot be negative';
        } else {
          this.emptyUabError();
          this.agencyUabCondition();
        }
        break;
      case TST.INTRASTATE:
        // value = Zero and (Origin in canArray))
        if (val === 0 && HhgCarrierRateFilingComponent.canOrgArrayConditionUab(origin)) {
          this.uabError = true;
          this.uabErrorMessage = `For Canadian Origin/Destination, UAB value should not be 0`;
          // value = Zero and (Destination in canArray)
        } else if (val === 0 && HhgCarrierRateFilingComponent.canOrgArrayConditionUab(destination)) {
          this.uabError = true;
          this.uabErrorMessage = `For Canadian Origin/Destination, UAB value should not be 0`;
          // !(origin in canArray or destination in canArray) and value != 0
        } else if (val < 0) {
          this.uabError = true;
          this.uabErrorMessage = 'UAB cannot be negative';
        } else if (val !== 0 && !(HhgCarrierRateFilingComponent.canOrgArrayConditionUab(origin) &&
          HhgCarrierRateFilingComponent.canOrgArrayConditionUab(destination))) {
          this.uabError = true;
          this.uabErrorMessage = `UAB should be 0 or blank`;
        } else {
          this.emptyUabError();
        }
        break;
      default:
        this.emptyUabError();
        break;
    }
  }

  /**
   * @description executes whenever there is a value change in category vehicle 1
   * @param val: category vehicle 1 input value
   */
  categoryVehicleValueChange(val, vehicleType) {
    vehicleType === VT.CLASSVEHICLE1 ? (this.emptyCategoryVehicle1Error(), this.emptyCategoryVehicle1Warning()) :
      vehicleType === VT.CLASSVEHICLE2 ? (this.emptyCategoryVehicle2Error(), this.emptyCategoryVehicle2Warning()) :
        vehicleType === VT.CLASSVEHICLE3 ? (this.emptyCategoryVehicle3Error(), this.emptyCategoryVehicle3Warning()) : console.log();
    if (val.indexOf('.') > -1) {
      vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I should be a whole number`) :
        vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II should be a whole number`) :
          vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III should be a whole number`) : console.log();
      return;
    }
    val = Number(val);
    const transportType = this.getFormField('transportType').value;
    const rateType = this.getFormField('rateTypeId').value;
    const agencyType = this.getFormField('sroMasterId').value;
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    switch (transportType) {
      case TST.INTERSTATE:
        // SRO != DOSHW and value = zero
        if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC &&  val === 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I cannot be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II cannot be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III cannot be 0 or blank`) : console.log();
          // (SRO != DOSHW )and (value < 30) and (origin not in orgArray)
        } else if (val < 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Category 1 vehicle rate cannot be negative`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Category 2 vehicle rate cannot be negative`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Category 3 vehicle rate cannot be negative`) : console.log();
        } else if (val < 0.30 && HhgCarrierRateFilingComponent.orgArrayConditionUab(origin) && agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate < $0.30.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate < $0.30.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate < $0.30.`) : console.log();
          // (SRO != DOSHW )and (value < 5) and (origin in orgArray)
        } else if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC && val < 5 && HhgCarrierRateFilingComponent.orgArrayConditionUab(origin)) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect Alaskan records with Category 1 vehicle rates < $5.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect Alaskan records with Category 2 vehicle rates < $5.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect Alaskan records with Category 3 vehicle rates < $5.00.`) : console.log();
          // (SRO != DOSHW )and (value > 20000) and (origin in orgArray)
        } else if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC && val > 20000 && HhgCarrierRateFilingComponent.orgArrayConditionUab(origin)) {
          this.categoryVehicle1Warning = true;
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect Alaskan records with Category 1 vehicle rates > $20,000.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect Alaskan records with Category 2 vehicle rates > $20,000.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect Alaskan records with Category 3 vehicle rates > $20,000.`) : console.log();
          // (SRO != DOSHW )and (value < 5) and (origin in desArray)
        } else if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC && val < 5 && (HhgCarrierRateFilingComponent.desArrayConditionUab(origin) || HhgCarrierRateFilingComponent.desArrayConditionUab(destination))) {
          // this.categoryVehicle1Warning = true;
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect Alaskan records with Category 1 vehicle rates < $5.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true , this.categoryVehicle2WarningMessage = `Suspect Alaskan records with Category 2 vehicle rates < $5.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true , this.categoryVehicle3WarningMessage = `Suspect Alaskan records with Category 3 vehicle rates < $5.00.`) : console.log();
          // (SRO != DOSHW )and (value < 30) and (origin not in desArray)
        } else if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC && val < 30 &&  (!HhgCarrierRateFilingComponent.desArrayConditionUab(origin) && !HhgCarrierRateFilingComponent.desArrayConditionUab(destination))) {
          // this.categoryVehicle1Warning = true;
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate < .30.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true , this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate < .30.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true , this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate < .30.`) : console.log();
          // (SRO != DOSHW )and (value > 20000) and (origin in desArray)
        } else if (agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC && val > 20000 && ((HhgCarrierRateFilingComponent.desArrayConditionUab(origin) || HhgCarrierRateFilingComponent.desArrayConditionUab(destination) ||
          origin.contiguousUS === 1 && destination.contiguousUS === 1))) {
          // this.categoryVehicle1Warning = true;
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true , this.categoryVehicle1WarningMessage = `Suspect records with Category 1 vehicle rates > $20,000.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true , this.categoryVehicle2WarningMessage = `Suspect records with Category 2 vehicle rates > $20,000.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true , this.categoryVehicle3WarningMessage = `Suspect records with Category 3 vehicle rates > $20,000.`) : console.log();
        } else if (agencyType.sroId === SRO.FDICC && val > 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I should be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II should be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III should be 0 or blank`) : console.log();
        } else {
          vehicleType === VT.CLASSVEHICLE1 ? (this.emptyCategoryVehicle1Error(), this.emptyCategoryVehicle1Warning()) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.emptyCategoryVehicle2Error(), this.emptyCategoryVehicle2Warning()) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.emptyCategoryVehicle3Error(), this.emptyCategoryVehicle3Warning()) : console.log();
        }
        break;
      case TST.INTERNATIONAL:
        // SRO != DOSHW and value = zero
        if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val === 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I Vehicle (< 300 cft) cannot be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II Vehicle (< 300 cft) cannot be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III Vehicle (< 300 cft) cannot be 0 or blank`) : console.log();
          // (SRO!= DOSHW) and (value >0 and < 1000)
        }  else if (val < 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Category 1 vehicle rate cannot be negative`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Category 2 vehicle rate cannot be negative`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Category 3 vehicle rate cannot be negative`) : console.log();
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 0 && val < 1000) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate <= $1000.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate <= $1000.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate <= $1000.00.`) : console.log();
          // (SRO!= DOSHW) and (value >20000)
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 20000) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate > $20000.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate > $20000.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate > $20000.00.`) : console.log();
          // (SRO!=DOSHW) and (origin=2200 THRU 2208) and (value >0 and <5)
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 20000 && HhgCarrierRateFilingComponent.desArrayConditionUab(origin) && val > 0 && val < 5) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate < $5.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate < $5.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate < $5.00.`) : console.log();
          // (SRO!=DOSHW) and (origin=2200 THRU 2208) and (value >20000)
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 20000 && HhgCarrierRateFilingComponent.desArrayConditionUab(origin)) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) : console.log();
          // (SRO!=DOSHW) and (destination=2200 THRU 2208) and (value >0 and <5)
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 0 && val < 5 && HhgCarrierRateFilingComponent.desArrayConditionUab(destination)) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate < $5.00.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate < $5.00.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate < $5.00.`) : console.log();
          // (SRO!=DOSHW) and (destination=2200 THRU 2208) and (value >20000)
        } else if ((agencyType.sroId !== SRO.DOSHW && agencyType.sroId !== SRO.FDICC) && val > 20000 && HhgCarrierRateFilingComponent.desArrayConditionUab(destination)) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate > $20000.If you need to edit, please click 'Cancel'`) : console.log();
        } else if ((agencyType.sroId === SRO.DOSHW && agencyType.sroId === SRO.FDICC) && val > 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I should be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II should be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III should be 0 or blank`) : console.log();
        } else {
          vehicleType === VT.CLASSVEHICLE1 ? (this.emptyCategoryVehicle1Error(), this.emptyCategoryVehicle1Warning()) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.emptyCategoryVehicle2Error(), this.emptyCategoryVehicle2Warning()) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.emptyCategoryVehicle3Error(), this.emptyCategoryVehicle3Warning()) : console.log();
        }
        break;
      case TST.INTRASTATE:
        // value = zero
        if (agencyType.sroId !== SRO.FDICC && val === 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I cannot be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II cannot be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III cannot be 0 or blank`) : console.log();
          // value > 0 and < 30
        }  else if (val < 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Category 1 vehicle rate cannot be negative`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Category 2 vehicle rate cannot be negative`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Category 3 vehicle rate cannot be negative`) : console.log();
        } else if (agencyType.sroId !== SRO.FDICC && val > 0 && val < 30) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Warning = true, this.categoryVehicle1WarningMessage = `Suspect records - Category 1 vehicle rate < $.30.`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Warning = true, this.categoryVehicle2WarningMessage = `Suspect records - Category 2 vehicle rate < $.30.`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Warning = true, this.categoryVehicle3WarningMessage = `Suspect records - Category 3 vehicle rate < $.30.`) : console.log();
          // (SRO!=DOSHW) and (origin=2200 THRU 2208) and (value >0 and <5)
        } else if (agencyType.sroId === SRO.FDICC && val > 0) {
          vehicleType === VT.CLASSVEHICLE1 ? (this.categoryVehicle1Error = true, this.categoryVehicle1ErrorMessage = `Vehicle Rate for Category I should be 0 or blank`) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.categoryVehicle2Error = true, this.categoryVehicle2ErrorMessage = `Vehicle Rate for Category II should be 0 or blank`) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.categoryVehicle3Error = true, this.categoryVehicle3ErrorMessage = `Vehicle Rate for Category III should be 0 or blank`) : console.log();
        } else {
          vehicleType === VT.CLASSVEHICLE1 ? (this.emptyCategoryVehicle1Error(), this.emptyCategoryVehicle1Warning()) :
            vehicleType === VT.CLASSVEHICLE2 ? (this.emptyCategoryVehicle2Error(), this.emptyCategoryVehicle2Warning()) :
              vehicleType === VT.CLASSVEHICLE3 ? (this.emptyCategoryVehicle3Error(), this.emptyCategoryVehicle3Warning()) : console.log();
        }
        break;
      default:
        vehicleType === VT.CLASSVEHICLE1 ? (this.emptyCategoryVehicle1Error(), this.emptyCategoryVehicle1Warning()) :
          vehicleType === VT.CLASSVEHICLE2 ? (this.emptyCategoryVehicle2Error(), this.emptyCategoryVehicle2Warning()) :
            vehicleType === VT.CLASSVEHICLE3 ? (this.emptyCategoryVehicle3Error(), this.emptyCategoryVehicle3Warning()) : console.log();
        break;
    }
  }

  /**
   * @description empties the categoryVehicle 1 field errors
   */
  emptyCategoryVehicle1Error() {
    this.categoryVehicle1Error = false;
    this.categoryVehicle1ErrorMessage = '';
  }

  /**
   * @description empties the categoryVehicle 1 field warnings
   */
  emptyCategoryVehicle1Warning() {
    this.categoryVehicle1Warning = false;
    this.categoryVehicle1WarningMessage = '';
  }

  /**
   * @description empties the categoryVehicle 2 field errors
   */
  emptyCategoryVehicle2Error() {
    this.categoryVehicle2Error = false;
    this.categoryVehicle2ErrorMessage = '';
  }

  /**
   * @description empties the categoryVehicle 2 field warnings
   */
  emptyCategoryVehicle2Warning() {
    this.categoryVehicle2Warning = false;
    this.categoryVehicle2WarningMessage = '';
  }

  /**
   * @description empties the categoryVehicle 3 field errors
   */
  emptyCategoryVehicle3Error() {
    this.categoryVehicle3Error = false;
    this.categoryVehicle3ErrorMessage = '';
  }

  /**
   * @description empties the categoryVehicle 3 field warnings
   */
  emptyCategoryVehicle3Warning() {
    this.categoryVehicle3Warning = false;
    this.categoryVehicle3WarningMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptySitError() {
    this.sitError = false;
    this.sitErrorMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptySitWarning() {
    this.sitWarning = false;
    this.sitWarningMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyAccSvcsError() {
    this.accSvcsError = false;
    this.accSvcsErrorMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyUabError() {
    this.uabError = false;
    this.uabErrorMessage = '';
  }

  assignUabError() {
    this.isUabMandatory = true;
    this.getFormField('unaccompaniedAirBag').setValidators([Validators.required]);
    this.uabError = true;
    this.uabErrorMessage = `UAB cannot be 0 for Alaskan/Canadian Origin/Destination`;
  }

  clearUabError() {
    this.getFormField('unaccompaniedAirBag').clearValidators();
    this.isUabMandatory = false;
    this.uabError = false;
    this.uabErrorMessage = ``;
  }

  clearUabOriginError() {
    this.uabOriginError = false;
  }

  /**
   * @description empties the packing discount field errors
   */
  emptyPackagingDiscountError() {
    this.packagingDiscountError = false;
    this.packagingDiscountErrorMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyPackagingDiscountWarning() {
    this.packagingDiscountWarning = false;
    this.packagingDiscountWarningMessage = '';
  }

  /**
   * @description empties the warehouse handling field errors
   */
  emptyWarehouseError() {
    this.wareHouseError = false;
    this.wareHouseErrorMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyWarehouseWarning() {
    this.wareHouseWarning = false;
    this.wareHouseWarningMessage = '';
  }

  /**
   * @description empties the monthly storage field errors
   */
  emptyMonthlyStorageError() {
    this.monthlyStorageError = false;
    this.monthlyStorageErrorMessage = '';
  }

  /**
   * @description empties the packing discount field warning
   */
  emptyMonthlyStorageWarning() {
    this.monthlyStorageWarning = false;
    this.monthlyStorageWarningMessage = '';
  }

  /**
   * @description empties the transportation % field errors
   */
  emptyTransportationError() {
    this.transportationError = false;
    this.transportationErrorMessage = '';
  }

  /**
   * @description empties the transportation % field warning
   */
  emptyTransportationWarning() {
    this.transportationWarning = false;
    this.transportationWarningMessage = '';
  }

  /* getFormField for hhgCarrierRates  */
  getFormField(field: string): any {
    return this.hhgCarrierRates.get(field);
  }

  // clearing all warnings after save
  emptyAllWarnings() {
    this.emptyCategoryVehicle1Warning();
    this.emptyCategoryVehicle2Warning();
    this.emptyCategoryVehicle3Warning();
    this.emptyWarehouseWarning();
    this.emptyTransportationWarning();
    this.emptyPackagingDiscountWarning();
    this.emptyMonthlyStorageWarning();
  }

  /* To disabled all fields in formGroup */
  disableAllFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.disable();
      }
    });
  }

  // Checking field status
  isFieldValid(field: string) {
    return !this.getFormField(field).valid && (this.getFormField(field).dirty || this.getFormField(field).touched);
  }

  // Checking field error
  hasErrors(field: string) {
    return this.getFormField(field).errors;
  }

  // To update the field value in form
  setFormGroupValue(prop: string, val: any) {
    this.hhgCarrierRates.patchValue({
      [prop]: val
    });
  }

  validateAllFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  /**
   * Check if field has validations or not
   * @param field
   * @param validator
   */
  hasValidator(field: string, validator?: string): boolean {
    return this.hasRequiredField(this.getFormField(field));
  }

  /**
   * checks if field required or not
   * @param formGroup
   */
  private hasRequiredField(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    if (abstractControl['controls']) {
      for (const controlName in abstractControl['controls']) {
        if (abstractControl['controls'][controlName]) {
          if (this.hasRequiredField(abstractControl['controls'][controlName])) {
            return true;
          }
        }
      }
    }
    return false;
  }

  precisionRound(number) {
    return Math.round(number * 100) / 100;
  }

  /**
   * To append number of val
   * @param val
   * @param numberToAppend
   */
  removeStringFromNumber(inStr: string) {
    return inStr !== null && inStr !== '' ? parseFloat(inStr.toString().replace(/[^\d.-]/g, '')) : null;
  }

  /**
   * @description checks if the rate record exists in scope table and procure table
   */
  checkRateRecordInProcureTable() {
    const origin = this.getFormField('originId').value;
    const destination = this.getFormField('destinationId').value;
    const type = this.getFormField('transportType').value;
    const sroId = this.getFormField('sroMasterId').value;
    const rateTypeId = this.getFormField('rateTypeId').value;

    if (this.originCondition() && this.destinationCondition()) {
      if (type === 'Interstate' && ((origin.stateCountryCode === 'CA' && destination.stateCountryCode === '0100') ||
        (origin.stateCountryCode === 'FL' && destination.stateCountryCode === '1200') ||
        (origin.stateCountryCode === 'CO' && destination.stateCountryCode === '0500') ||
        HhgCarrierRateFilingComponent.alaskaOriginDestinationCondition(origin, destination) ||
        HhgCarrierRateFilingComponent.canadaOriginDestinationCondition(origin, destination))) {
        this.destinationError = true;
        this.destinationErrorMessage = `Same Origin and Destination cannot be allowed for interstate`;
      } else {
        this.hhgService.getOriginDestinationValidation(destination.stateCountryId, origin.stateCountryId, this.carrierId, type).subscribe(response => {
          if (response === false) {
            this.destinationError = true;
            this.destinationErrorMessage = 'Selected Origin, Destination is not in your scope';
          } else {
            this.emptyDestinationTypeErrors();
          }
        }, error => {
          this.emptyDestinationTypeErrors();
          this.alertService.error(`Couldn't able to get the record from the tsp scope. Please contact system administrator or try again after sometime.`);
        });
      }
      this.hhgService.getOriginDestinationProcureValidation(this.carrierId, destination.stateCountryId, origin.stateCountryId, sroId.sroMasterId, rateTypeId).subscribe(response => {
        if (response === true) {
          this.destinationProcureError = true;
          this.destinationProcureErrorMessage = 'Current record exists, Please update it through edit rates';
        } else {
          this.emptyDestinationTypeProcureErrors();
        }
      }, error => {
        this.emptyDestinationTypeErrors();
        this.alertService.error(`Couldn't able to get the record from procurement table. Please contact system administrator or try again after sometime.`);
      });
    }
  }

  /**
   * @description validation if origin has some value and origin errors are empty
   */
  originCondition() {
    const origin = this.getFormField('originId').value;
    // return origin !== null && origin !== undefined && origin !== '' ? this.originError === false && this.originErrorMessage === '' : false;
    return null !== origin && origin !== undefined && origin !== '';
  }

  /**
   * @description validation if destination has some value and origin errors are empty
   */
  destinationCondition() {
    const destination = this.getFormField('destinationId').value;
    // return destination !== null && destination !== undefined && destination !== '' ? this.destinationError === false && this.destinationErrorMessage === '' : false;
    return destination !== null && destination !== undefined && destination !== '';
  }

  /**
   * @description validates the agency and uab field combination for agency errors
   */
  // SRO = "DOSBG" and UAB > Zero	Agency Id DOSBG should not have UAB Weight
  agencyUabCondition() {
    const agencyType = this.getFormField('sroMasterId').value;
    const uab = this.getFormField('unaccompaniedAirBag').value;
    if ((agencyType !== '' && agencyType !== null && agencyType !== undefined) && (uab !== '' && uab !== null && uab !== undefined) &&
      (this.agencyError === false && this.agencyErrorMessage === '') && (this.uabError === false && this.uabErrorMessage === '')) {
      if (agencyType.sroId === SRO.DOSBG && uab > 0) {
        this.agencyError = true;
        this.agencyErrorMessage = 'SRO Id DOSBG should not have UAB Weight';
      } else {
        this.emptyAgencyTypeErrors();
      }
    } else {
      console.log();
    }
  }

  /**
   * @description returns true if there are no errors for the validated fields and enables save.
   */
  disableSave() {
    if (this.rateTypeError === true || this.agencyError === true || this.originError === true || this.destinationError === true || this.packagingDiscountError === true ||
      this.wareHouseError === true || this.monthlyStorageError === true || this.transportationError === true || this.sitError === true || this.accSvcsError === true ||
      this.uabError === true || this.discountFieldMonthlyStorageError === true || this.discountFieldSitError === true ||
      this.categoryVehicle1Error === true || this.categoryVehicle2Error === true || this.categoryVehicle3Error === true) {
      return true;
    }
    return false;
  }

  /**
   * @description resets all the input form controls under discounts.
   */
  resetDiscounts() {
    this.hhgCarrierRates.controls.linehaul.setValue(null);
    this.hhgCarrierRates.controls.classVehicle1.setValue(null);
    this.hhgCarrierRates.controls.classVehicle2.setValue(null);
    this.hhgCarrierRates.controls.classVehicle3.setValue(null);
    this.hhgCarrierRates.controls.storageInTransit.setValue(null);
    this.hhgCarrierRates.controls.accessorials.setValue(null);
    this.hhgCarrierRates.controls.unaccompaniedAirBag.setValue(null);
  }

  /**
   * @description saves the current rate object when user clicks on save
   * @param formObj: the current form object with all the values.
   */
  saveOnlineRates(formObj) {
    this.tmssloader.show();
    const destId = this.getFormField('destinationId').value;
    const orginId = this.getFormField('originId').value;
    const sroMasterId = this.getFormField('sroMasterId').value;
    // setting Unknown Service Area for extended storage since we dont have destination
    formObj.destinationId = (destId.stateCountryId !== null && destId.stateCountryId !== undefined ) ? destId.stateCountryId : 374;
    formObj.originId = orginId.stateCountryId;
    formObj.sroMasterId = sroMasterId.sroMasterId;
    const item = this.rateTypes.find(item => item.legacyRateType === formObj.rateTypeId);
    formObj.rateTypeId = item.rateTypeId;
    formObj.carrierId = this.carrierId;
    formObj.classVehicle1 = Number(formObj.classVehicle1);
    formObj.classVehicle2 = Number(formObj.classVehicle2);
    formObj.classVehicle3 = Number(formObj.classVehicle3);
    formObj.linehaul = Number(formObj.linehaul);
    formObj.storageInTransit = Number(formObj.storageInTransit);
    formObj.accessorials = Number(formObj.accessorials);
    formObj.unaccompaniedAirBag = Number(formObj.unaccompaniedAirBag);
    if (AppConstants.isNotNullCondition(formObj.destinationId) && formObj.destinationId !== 374) {
      formObj.destinationType = (formObj.destinationId.stateCountryType === stateCountry.STATE || formObj.destinationId.stateCountryType === stateCountry.COUNTRY) ? stateCountry.STATECOUNTRY : stateCountry.SERVICEAREA;
    } else {
      formObj.destinationType = stateCountry.SERVICEAREA;
    }
    formObj.ratesBidcyclesId = this.ratesBidcycle;
    formObj.ratesBidCyclesName = this.bidcycleName;
    this.hhgService.saveOnlineHhgRate(formObj).subscribe(result => {
      this.alertService.success('Addition successful');
      this.isErrorMessages = false;
      setTimeout(() => {
        // resetting the form
        this.hhgCarrierRates.reset();
        // clearing all warnings after save
        this.emptyAllWarnings();
      }, 2500);
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      if (error.error !== null && error.error !== undefined) {
        this.errorMessages = error.error;
        if (this.errorMessages[0].errorMessage !== null && this.errorMessages[0].errorMessage !== undefined) {
          this.isErrorMessages = true;
        } else {
          this.isErrorMessages = false;
        }
      } else {
        this.errorMessages = 'Failed to save the current hhg online rate filing. Please try again after sometime or contact system administrator';
        this.alertService.info(this.errorMessages);
      }
    });
  }

  /**
   * destroying the subscription
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * @description sorts array of objects alphabetically based on one property
   * @param objArray
   * @returns {any}
   */
  sortingArray(objArray) {
    return objArray.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1)
      .sort(function (a, b) {
        const textA = a.stateCountryName.toUpperCase();
        const textB = b.stateCountryName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
  }

  /**
   *  validating for testing purpose only it will return invalid fields
   */
  validateForm() {
    AppConstants.getFormValidationErrors(this.hhgCarrierRates);
  }
}
